export const data = {
  20240610142127: {
    test_execution_history: {
      // cm_reporting_scenario_overall_details
      Test_case_execution_id: "20240610142127",
      Model: "CS300",
      Execution: "Closed Loop",
      Executed_by: "Application",
      StartedAt: "2024-06-10 02:18:43",
      Mandatory_Target: {
        Total_Variations_Executed: 22,
        Passed: 10,
        Failed: 11,
        Pass_Percentage: "45.45%",
      },
      Development_Target: {
        Total_Variations_Executed: 22,
        Passed: 9,
        Failed: 12,
        Pass_Percentage: "40.91%",
      },
      Status: "Complete",
      Total_Scenarios_Executed: 6,
      Scenarios_Executed: [
        "1500H10",
        "1500H21",
        "1501EUR_70",
        "1600CIS",
        "1600EUR",
        "1600HND_N160",
      ],
    },
    test_summary: [
      {
        // cm_reporting_scenario_details
        execution_id: "20240610142127",
        summary: {
          uuid: "sdjfkjsdhfkjhkj",
          Scenario: "1500H10",
          Mandatory_Target: {
            Total_Variations_Executed: 4,
            Passed: 3,
            Failed: 1,
            Pass_Percentage: 75,
          },
          Development_Target: {
            Total_Variations_Executed: 4,
            Passed: 3,
            Failed: 1,
            Pass_Percentage: 75,
          },
        },
        variations: [
          {
            // cm_reporting_scenario_variation_details id =""
            uuid: "1500H10142127",
            name: "p1003030-p180",
            InputParameters: {
              EV_InitPos_m: 416,
              EV_InitSpd_Kmph: 30,
              Tgt_InitPos_m: 412.45691609977325,
              Tgt_InitSpd_Kmph: 30,
              Tgt_LatPos_m: 3.5,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1500H10142127",
            name: "p1004040-p180",
            InputParameters: {
              EV_InitPos_m: 389,
              EV_InitSpd_Kmph: 40,
              Tgt_InitPos_m: 382.70118417737467,
              Tgt_InitSpd_Kmph: 40,
              Tgt_LatPos_m: 3.5,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1500H10142127",
            name: "p1006060-p180",
            InputParameters: {
              EV_InitPos_m: 333,
              EV_InitSpd_Kmph: 60,
              Tgt_InitPos_m: 318.82766439909295,
              Tgt_InitSpd_Kmph: 60,
              Tgt_LatPos_m: 3.5,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1500H10142127",
            name: "p1008080-p180",
            InputParameters: {
              EV_InitPos_m: 277,
              EV_InitSpd_Kmph: 80,
              Tgt_InitPos_m: 251.80473670949863,
              Tgt_InitSpd_Kmph: 80,
              Tgt_LatPos_m: 3.5,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 53.39 km/h.",
          },
        ],
      },
      {
        execution_id: "20240610142127",
        summary: {
          uuid: "1500H21142127",
          Scenario: "1500H21",
          Mandatory_Target: {
            Total_Variations_Executed: 6,
            Passed: 5,
            Failed: 1,
            Pass_Percentage: 83.33,
          },
          Development_Target: {
            Total_Variations_Executed: 6,
            Passed: 5,
            Failed: 1,
            Pass_Percentage: 83.33,
          },
        },
        variations: [
          {
            uuid: "1500H21142127",
            name: "p1003030-p180",
            InputParameters: {
              Calc_Tgt_Offset_LC: -3.5,
              EV_InitPos_m: 367.24633,
              EV_InitSpd_Kmph: 30,
              LC_Len_m: 28,
              T_LC: 3.78,
              Tgt_InitPos_m: 447.62357609977323,
              Tgt_InitSpd_Kmph: 30,
              Tgt_LC_offset: 3.5,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1500H21142127",
            name: "p1004040-p180",
            InputParameters: {
              Calc_Tgt_Offset_LC: -3.5,
              EV_InitPos_m: 324.52411,
              EV_InitSpd_Kmph: 40,
              LC_Len_m: 36,
              T_LC: 3.78,
              Tgt_InitPos_m: 429.92340417737466,
              Tgt_InitSpd_Kmph: 40,
              Tgt_LC_offset: 3.5,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1500H21142127",
            name: "p1005050-p180",
            InputParameters: {
              Calc_Tgt_Offset_LC: -3.5,
              EV_InitPos_m: 281.80188,
              EV_InitSpd_Kmph: 50,
              LC_Len_m: 44,
              T_LC: 3.78,
              Tgt_InitPos_m: 411.4358702771479,
              Tgt_InitSpd_Kmph: 50,
              Tgt_LC_offset: 3.5,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1500H21142127",
            name: "p1006060-p180",
            InputParameters: {
              Calc_Tgt_Offset_LC: -3.5,
              EV_InitPos_m: 239.07966,
              EV_InitSpd_Kmph: 60,
              LC_Len_m: 52,
              T_LC: 3.78,
              Tgt_InitPos_m: 392.16099439909294,
              Tgt_InitSpd_Kmph: 60,
              Tgt_LC_offset: 3.5,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1500H21142127",
            name: "p1007070-p180",
            InputParameters: {
              Calc_Tgt_Offset_LC: -3.5,
              EV_InitPos_m: 196.35744,
              EV_InitSpd_Kmph: 70,
              LC_Len_m: 60,
              T_LC: 3.78,
              Tgt_InitPos_m: 372.09875654320984,
              Tgt_InitSpd_Kmph: 70,
              Tgt_LC_offset: 3.5,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1500H21142127",
            name: "p1008080-p180",
            InputParameters: {
              Calc_Tgt_Offset_LC: -3.5,
              EV_InitPos_m: 153.63502,
              EV_InitSpd_Kmph: 80,
              LC_Len_m: 68,
              T_LC: 3.78,
              Tgt_InitPos_m: 351.24917670949861,
              Tgt_InitSpd_Kmph: 80,
              Tgt_LC_offset: 3.5,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 50.91 km/h.",
          },
        ],
      },
      {
        execution_id: "20240610142127",
        summary: {
          uuid: "1501EUR_70142127",
          Scenario: "1501EUR_70",
          Mandatory_Target: {
            Total_Variations_Executed: 1,
            Passed: 0,
            Failed: 1,
            Pass_Percentage: 0,
          },
          Development_Target: {
            Total_Variations_Executed: 1,
            Passed: 0,
            Failed: 1,
            Pass_Percentage: 0,
          },
        },
        variations: [
          {
            uuid: "1501EUR_70142127",
            name: "p1007070-p180",
            InputParameters: {
              EV_InitPos_m: 174.17,
              EV_InitSpd_Kmph: 70,
              Tgt_InitPos_m: 188.70987654320987,
              Tgt_InitSpd_Kmph: 70,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by -0.00 km/h.",
          },
        ],
      },
      {
        execution_id: "20240610142127",
        summary: {
          uuid: "1600CIS142127",
          Scenario: "1600CIS",
          Mandatory_Target: {
            Total_Variations_Executed: 1,
            Passed: 0,
            Failed: 0,
            Pass_Percentage: 0,
          },
          Development_Target: {
            Total_Variations_Executed: 1,
            Passed: 0,
            Failed: 0,
            Pass_Percentage: 0,
          },
        },
        variations: [
          {
            uuid: "1600CIS142127",
            name: "p0501530-p090",
            InputParameters: {
              Curved_Buffer_m: 5.2,
              EV_ColPoint_m: 393.52,
              EV_InitPos_m: 335.1867,
              EV_InitSpd_Kmph: 15,
              EV_StartCond_m: 384.5,
              TTC_s: 4,
              Tgt_InitPos_m: 275.95691609977325,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "ERROR" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "ERROR" },
            Remarks:
              'No match found for scenario-variation pair "1600CIS - p0501530-p090".',
          },
        ],
      },
      {
        execution_id: "20240610142127",
        summary: {
          uuid: "1600EUR142127",
          Scenario: "1600EUR",
          Mandatory_Target: {
            Total_Variations_Executed: 9,
            Passed: 1,
            Failed: 8,
            Pass_Percentage: 11.11,
          },
          Development_Target: {
            Total_Variations_Executed: 9,
            Passed: 1,
            Failed: 8,
            Pass_Percentage: 11.11,
          },
        },
        variations: [
          {
            uuid: "1600EUR142127",
            name: "p0501030-p090",
            InputParameters: {
              Curved_Buffer_m: 4.18,
              EV_ColPoint_m: 395.081,
              EV_InitPos_m: 356.1921,
              EV_InitSpd_Kmph: 10,
              EV_StartCond_m: 389,
              TTC_s: 4,
              Tgt_InitPos_m: 359.35021609977326,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 15.77 sec.",
          },
          {
            uuid: "1600EUR142127",
            name: "p0501045-p090",
            InputParameters: {
              Curved_Buffer_m: 4.18,
              EV_ColPoint_m: 395.081,
              EV_InitPos_m: 356.1921,
              EV_InitSpd_Kmph: 10,
              EV_StartCond_m: 389,
              TTC_s: 4,
              Tgt_InitPos_m: 338.25466122448984,
              Tgt_InitSpd_Kmph: 45,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 15.83 sec.",
          },
          {
            uuid: "1600EUR142127",
            name: "p0501060-p090",
            InputParameters: {
              Curved_Buffer_m: 4.18,
              EV_ColPoint_m: 395.081,
              EV_InitPos_m: 356.1921,
              EV_InitSpd_Kmph: 10,
              EV_StartCond_m: 389,
              TTC_s: 4,
              Tgt_InitPos_m: 315.82766439909295,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1600EUR142127",
            name: "p0501530-p090",
            InputParameters: {
              Curved_Buffer_m: 5.2,
              EV_ColPoint_m: 393.52,
              EV_InitPos_m: 335.1867,
              EV_InitSpd_Kmph: 15,
              EV_StartCond_m: 384.5,
              TTC_s: 4,
              Tgt_InitPos_m: 361.78351609977324,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 15.15 sec.",
          },
          {
            uuid: "1600EUR142127",
            name: "p0501545-p090",
            InputParameters: {
              Curved_Buffer_m: 5.2,
              EV_ColPoint_m: 393.52,
              EV_InitPos_m: 335.1867,
              EV_InitSpd_Kmph: 15,
              EV_StartCond_m: 384.5,
              TTC_s: 4,
              Tgt_InitPos_m: 340.68796122448981,
              Tgt_InitSpd_Kmph: 45,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 15.37 sec.",
          },
          {
            uuid: "1600EUR142127",
            name: "p0501560-p090",
            InputParameters: {
              Curved_Buffer_m: 5.2,
              EV_ColPoint_m: 393.52,
              EV_InitPos_m: 335.1867,
              EV_InitSpd_Kmph: 15,
              EV_StartCond_m: 384.5,
              TTC_s: 4,
              Tgt_InitPos_m: 318.387564399093,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 15.37 sec.",
          },
          {
            uuid: "1600EUR142127",
            name: "p0502030-p090",
            InputParameters: {
              Curved_Buffer_m: 4.8,
              EV_ColPoint_m: 392.6176,
              EV_InitPos_m: 314.8398,
              EV_InitSpd_Kmph: 20,
              EV_StartCond_m: 381.5,
              TTC_s: 4,
              Tgt_InitPos_m: 363.22171609977323,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 14.95 sec.",
          },
          {
            uuid: "1600EUR142127",
            name: "p0502045-p090",
            InputParameters: {
              Curved_Buffer_m: 4.8,
              EV_ColPoint_m: 392.6176,
              EV_InitPos_m: 314.8398,
              EV_InitSpd_Kmph: 20,
              EV_StartCond_m: 381.5,
              TTC_s: 4,
              Tgt_InitPos_m: 342.02626122448982,
              Tgt_InitSpd_Kmph: 45,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 14.81 sec.",
          },
          {
            uuid: "1600EUR142127",
            name: "p0502060-p090",
            InputParameters: {
              Curved_Buffer_m: 4.8,
              EV_ColPoint_m: 392.6176,
              EV_InitPos_m: 314.8398,
              EV_InitSpd_Kmph: 20,
              EV_StartCond_m: 381.5,
              TTC_s: 4,
              Tgt_InitPos_m: 319.82586439909295,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 14.81 sec.",
          },
        ],
      },
      {
        execution_id: "20240610142127",
        summary: {
          uuid: "1600HND_N160142127",
          Scenario: "1600HND_N160",
          Mandatory_Target: {
            Total_Variations_Executed: 1,
            Passed: 1,
            Failed: 0,
            Pass_Percentage: 100,
          },
          Development_Target: {
            Total_Variations_Executed: 1,
            Passed: 0,
            Failed: 1,
            Pass_Percentage: 0,
          },
        },
        variations: [
          {
            uuid: "1600HND_N160142127",
            name: "p0501030-n160",
            InputParameters: {
              EV_InitPos_m: 1940,
              EV_InitSpd_Kmph: 10,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Collision occurred at 21.94 sec.\n\nNot tested for KPI "-".',
          },
        ],
      },
    ],
  },
  20240610142208: {
    test_execution_history: {
      Test_case_execution_id: "20240610142208",
      Model: "CS300",
      Execution: "Closed Loop",
      Executed_by: "Application",
      StartedAt: "2024-06-02 10:20:23",
      Mandatory_Target: {
        Total_Variations_Executed: 54,
        Passed: 53,
        Failed: 1,
        Pass_Percentage: "98.15%",
      },
      Development_Target: {
        Total_Variations_Executed: 54,
        Passed: 51,
        Failed: 3,
        Pass_Percentage: "94.44%",
      },
      Status: "Complete",
      Total_Scenarios_Executed: 4,
      Scenarios_Executed: ["1100IHS", "1100JPN", "1101HND", "1102CIS"],
    },
    test_summary: [
      {
        execution_id: "20240610142208",
        summary: {
          uuid: "1100IHS142208",
          Scenario: "1100IHS",
          Mandatory_Target: {
            Total_Variations_Executed: 2,
            Passed: 2,
            Failed: 0,
            Pass_Percentage: 100,
          },
          Development_Target: {
            Total_Variations_Executed: 2,
            Passed: 2,
            Failed: 0,
            Pass_Percentage: 100,
          },
        },
        variations: [
          {
            uuid: "1100IHS142208",
            name: "p1002000-p000",
            InputParameters: {
              EV_InitPos_m: 100.8,
              EV_InitSpd_Kmph: 20,
              Overlap_per: 100,
              Tgt_InitPos_m: 250.8,
              Tgt_LatPos_m: 1.83,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100IHS142208",
            name: "p1004000-p000",
            InputParameters: {
              EV_InitPos_m: 100.8,
              EV_InitSpd_Kmph: 40,
              Overlap_per: 100,
              Tgt_InitPos_m: 300,
              Tgt_LatPos_m: 1.83,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
        ],
      },
      {
        execution_id: "20240610142208",
        summary: {
          uuid: "1100JPN142208",
          Scenario: "1100JPN",
          Mandatory_Target: {
            Total_Variations_Executed: 11,
            Passed: 10,
            Failed: 1,
            Pass_Percentage: 90.91,
          },
          Development_Target: {
            Total_Variations_Executed: 11,
            Passed: 10,
            Failed: 1,
            Pass_Percentage: 90.91,
          },
        },
        variations: [
          {
            uuid: "1100JPN142208",
            name: "p1001000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 10,
              Overlap_per: 100,
              Tgt_InitPos_m: 141.66,
              Tgt_LatPos_m: 1.75,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100JPN142208",
            name: "p1001500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 15,
              Overlap_per: 100,
              Tgt_InitPos_m: 162.5,
              Tgt_LatPos_m: 1.75,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100JPN142208",
            name: "p1002000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 20,
              Overlap_per: 100,
              Tgt_InitPos_m: 183.33,
              Tgt_LatPos_m: 1.75,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100JPN142208",
            name: "p1002500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 25,
              Overlap_per: 100,
              Tgt_InitPos_m: 204.166,
              Tgt_LatPos_m: 1.75,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100JPN142208",
            name: "p1003000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 30,
              Overlap_per: 100,
              Tgt_InitPos_m: 225,
              Tgt_LatPos_m: 1.75,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100JPN142208",
            name: "p1003500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 35,
              Overlap_per: 100,
              Tgt_InitPos_m: 245.833,
              Tgt_LatPos_m: 1.75,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100JPN142208",
            name: "p1004000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 40,
              Overlap_per: 100,
              Tgt_InitPos_m: 266.66,
              Tgt_LatPos_m: 1.75,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100JPN142208",
            name: "p1004500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 45,
              Overlap_per: 100,
              Tgt_InitPos_m: 287.5,
              Tgt_LatPos_m: 1.75,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100JPN142208",
            name: "p1005000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 50,
              Overlap_per: 100,
              Tgt_InitPos_m: 308.33,
              Tgt_LatPos_m: 1.75,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100JPN142208",
            name: "p1005500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 55,
              Overlap_per: 100,
              Tgt_InitPos_m: 329.166,
              Tgt_LatPos_m: 1.75,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 15.74 sec.",
          },
          {
            uuid: "1100JPN142208",
            name: "p1006000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 60,
              Overlap_per: 100,
              Tgt_InitPos_m: 350,
              Tgt_LatPos_m: 1.75,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
        ],
      },
      {
        execution_id: "20240610142208",
        summary: {
          uuid: "1101HND142208",
          Scenario: "1101HND",
          Mandatory_Target: {
            Total_Variations_Executed: 40,
            Passed: 40,
            Failed: 0,
            Pass_Percentage: 100,
          },
          Development_Target: {
            Total_Variations_Executed: 40,
            Passed: 38,
            Failed: 2,
            Pass_Percentage: 95,
          },
        },
        variations: [
          {
            uuid: "1101HND142208",
            name: "n0250500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 5,
              Obs1_InitPos_m: 122.3888,
              Obs1_LatPos_m: -1.75,
              Obs2_InitPos_m: 130.3888,
              Obs2_LatPos_m: 2.4,
              Overlap_per: -25,
              Tgt_InitPos_m: 126.3888,
              Tgt_LatPos_m: 0.41,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "n0251000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 10,
              Obs1_InitPos_m: 148.7778,
              Obs1_LatPos_m: -1.75,
              Obs2_InitPos_m: 152.7778,
              Obs2_LatPos_m: 2.4,
              Overlap_per: -25,
              Tgt_InitPos_m: 148.7778,
              Tgt_LatPos_m: 0.41,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "n0251500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 15,
              Obs1_InitPos_m: 175,
              Obs1_LatPos_m: -1.75,
              Obs2_InitPos_m: 183.1667,
              Obs2_LatPos_m: 2.4,
              Overlap_per: -25,
              Tgt_InitPos_m: 179.1667,
              Tgt_LatPos_m: 0.41,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "n0252000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 20,
              Obs1_InitPos_m: 201,
              Obs1_LatPos_m: -1.75,
              Obs2_InitPos_m: 209.5556,
              Obs2_LatPos_m: 2.4,
              Overlap_per: -25,
              Tgt_InitPos_m: 205.5556,
              Tgt_LatPos_m: 0.41,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "n0252500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 25,
              Obs1_InitPos_m: 227,
              Obs1_LatPos_m: -1.75,
              Obs2_InitPos_m: 235.9444,
              Obs2_LatPos_m: 2.4,
              Overlap_per: -25,
              Tgt_InitPos_m: 231.9444,
              Tgt_LatPos_m: 0.41,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "n0253000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 30,
              Obs1_InitPos_m: 254,
              Obs1_LatPos_m: -1.75,
              Obs2_InitPos_m: 262.3333,
              Obs2_LatPos_m: 2.4,
              Overlap_per: -25,
              Tgt_InitPos_m: 258.3333,
              Tgt_LatPos_m: 0.41,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "n0253500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 35,
              Obs1_InitPos_m: 280,
              Obs1_LatPos_m: -1.75,
              Obs2_InitPos_m: 288.7222,
              Obs2_LatPos_m: 2.4,
              Overlap_per: -25,
              Tgt_InitPos_m: 284.7222,
              Tgt_LatPos_m: 0.41,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "n0254000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 40,
              Obs1_InitPos_m: 307,
              Obs1_LatPos_m: -1.75,
              Obs2_InitPos_m: 315.1111,
              Obs2_LatPos_m: 2.4,
              Overlap_per: -25,
              Tgt_InitPos_m: 311.1111,
              Tgt_LatPos_m: 0.41,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "n0254500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 45,
              Obs1_InitPos_m: 334,
              Obs1_LatPos_m: -1.75,
              Obs2_InitPos_m: 341.5,
              Obs2_LatPos_m: 2.4,
              Overlap_per: -25,
              Tgt_InitPos_m: 337.5,
              Tgt_LatPos_m: 0.41,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "n0255000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 50,
              Obs1_InitPos_m: 359,
              Obs1_LatPos_m: -1.75,
              Obs2_InitPos_m: 367.8889,
              Obs2_LatPos_m: 2.4,
              Overlap_per: -25,
              Tgt_InitPos_m: 363.8889,
              Tgt_LatPos_m: 0.41,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "n0255500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 55,
              Obs1_InitPos_m: 286,
              Obs1_LatPos_m: -1.75,
              Obs2_InitPos_m: 394.2778,
              Obs2_LatPos_m: 2.4,
              Overlap_per: -25,
              Tgt_InitPos_m: 390.2778,
              Tgt_LatPos_m: 0.41,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Collision occurred at 19.74 sec.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "n0256000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 60,
              Obs1_InitPos_m: 412,
              Obs1_LatPos_m: -1.75,
              Obs2_InitPos_m: 420.6667,
              Obs2_LatPos_m: 2.4,
              Overlap_per: -25,
              Tgt_InitPos_m: 416.6667,
              Tgt_LatPos_m: 0.41,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "n0256500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 65,
              Obs1_InitPos_m: 439,
              Obs1_LatPos_m: -1.75,
              Obs2_InitPos_m: 447.0556,
              Obs2_LatPos_m: 2.4,
              Overlap_per: -25,
              Tgt_InitPos_m: 443.0556,
              Tgt_LatPos_m: 0.41,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks:
              'No collision occurred.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "n0257000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 70,
              Obs1_InitPos_m: 465,
              Obs1_LatPos_m: -1.75,
              Obs2_InitPos_m: 473.4444,
              Obs2_LatPos_m: 2.4,
              Overlap_per: -25,
              Tgt_InitPos_m: 469.4444,
              Tgt_LatPos_m: 0.41,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks:
              'No collision occurred.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "n0257500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 75,
              Obs1_InitPos_m: 491,
              Obs1_LatPos_m: -1.75,
              Obs2_InitPos_m: 499.8333,
              Obs2_LatPos_m: 2.4,
              Overlap_per: -25,
              Tgt_InitPos_m: 495.8333,
              Tgt_LatPos_m: 0.41,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks:
              'No collision occurred.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "n0258000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 80,
              Obs1_InitPos_m: 518,
              Obs1_LatPos_m: -1.75,
              Obs2_InitPos_m: 526.2222,
              Obs2_LatPos_m: 2.4,
              Overlap_per: -25,
              Tgt_InitPos_m: 522.2222,
              Tgt_LatPos_m: 0.41,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks:
              'No collision occurred.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "n0258500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 85,
              Obs1_InitPos_m: 544,
              Obs1_LatPos_m: -1.75,
              Obs2_InitPos_m: 552.6111,
              Obs2_LatPos_m: 2.4,
              Overlap_per: -25,
              Tgt_InitPos_m: 548.6111,
              Tgt_LatPos_m: 0.41,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks:
              'No collision occurred.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "n0259000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 90,
              Obs1_InitPos_m: 571,
              Obs1_LatPos_m: -1.75,
              Obs2_InitPos_m: 579,
              Obs2_LatPos_m: 2.4,
              Overlap_per: -25,
              Tgt_InitPos_m: 575,
              Tgt_LatPos_m: 0.41,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks:
              'No collision occurred.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "n0259500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 95,
              Obs1_InitPos_m: 597,
              Obs1_LatPos_m: -1.75,
              Obs2_InitPos_m: 605.3888,
              Obs2_LatPos_m: 2.4,
              Overlap_per: -25,
              Tgt_InitPos_m: 601.3888,
              Tgt_LatPos_m: 0.41,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "n0259600-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 96,
              Obs1_InitPos_m: 602,
              Obs1_LatPos_m: -1.75,
              Obs2_InitPos_m: 610.6666,
              Obs2_LatPos_m: 2.4,
              Overlap_per: -25,
              Tgt_InitPos_m: 606.6666,
              Tgt_LatPos_m: 0.41,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "p0250500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 5,
              Obs1_InitPos_m: 122.3888,
              Obs1_LatPos_m: -0.5,
              Obs2_InitPos_m: 0,
              Obs2_LatPos_m: -1.75,
              Overlap_per: 25,
              Tgt_InitPos_m: 126.3888,
              Tgt_LatPos_m: 3.1,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "p0251000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 10,
              Obs1_InitPos_m: 148.7778,
              Obs1_LatPos_m: -0.5,
              Obs2_InitPos_m: 0,
              Obs2_LatPos_m: -1.75,
              Overlap_per: 25,
              Tgt_InitPos_m: 152.7778,
              Tgt_LatPos_m: 3.1,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "p0251500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 15,
              Obs1_InitPos_m: 175,
              Obs1_LatPos_m: -0.5,
              Obs2_InitPos_m: 0,
              Obs2_LatPos_m: -1.75,
              Overlap_per: 25,
              Tgt_InitPos_m: 179.1667,
              Tgt_LatPos_m: 3.1,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "p0252000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 20,
              Obs1_InitPos_m: 201,
              Obs1_LatPos_m: -0.5,
              Obs2_InitPos_m: 0,
              Obs2_LatPos_m: -1.75,
              Overlap_per: 25,
              Tgt_InitPos_m: 205.5556,
              Tgt_LatPos_m: 3.1,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "p0252500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 25,
              Obs1_InitPos_m: 227,
              Obs1_LatPos_m: -0.5,
              Obs2_InitPos_m: 0,
              Obs2_LatPos_m: -1.75,
              Overlap_per: 25,
              Tgt_InitPos_m: 231.9444,
              Tgt_LatPos_m: 3.1,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "p0253000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 30,
              Obs1_InitPos_m: 254,
              Obs1_LatPos_m: -0.5,
              Obs2_InitPos_m: 0,
              Obs2_LatPos_m: -1.75,
              Overlap_per: 25,
              Tgt_InitPos_m: 258.3333,
              Tgt_LatPos_m: 3.1,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "p0253500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 35,
              Obs1_InitPos_m: 280,
              Obs1_LatPos_m: -0.5,
              Obs2_InitPos_m: 0,
              Obs2_LatPos_m: -1.75,
              Overlap_per: 25,
              Tgt_InitPos_m: 284.7222,
              Tgt_LatPos_m: 3.1,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "p0254000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 40,
              Obs1_InitPos_m: 307,
              Obs1_LatPos_m: -0.5,
              Obs2_InitPos_m: 0,
              Obs2_LatPos_m: -1.75,
              Overlap_per: 25,
              Tgt_InitPos_m: 311.1111,
              Tgt_LatPos_m: 3.1,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "p0254500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 45,
              Obs1_InitPos_m: 334,
              Obs1_LatPos_m: -0.5,
              Obs2_InitPos_m: 0,
              Obs2_LatPos_m: -1.75,
              Overlap_per: 25,
              Tgt_InitPos_m: 337.5,
              Tgt_LatPos_m: 3.1,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "p0255000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 50,
              Obs1_InitPos_m: 359,
              Obs1_LatPos_m: -0.5,
              Obs2_InitPos_m: 0,
              Obs2_LatPos_m: -1.75,
              Overlap_per: 25,
              Tgt_InitPos_m: 363.8889,
              Tgt_LatPos_m: 3.1,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "p0255500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 55,
              Obs1_InitPos_m: 286,
              Obs1_LatPos_m: -0.5,
              Obs2_InitPos_m: 0,
              Obs2_LatPos_m: -1.75,
              Overlap_per: 25,
              Tgt_InitPos_m: 390.2778,
              Tgt_LatPos_m: 3.1,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Collision occurred at 19.74 sec.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "p0256000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 60,
              Obs1_InitPos_m: 412,
              Obs1_LatPos_m: -0.5,
              Obs2_InitPos_m: 0,
              Obs2_LatPos_m: -1.75,
              Overlap_per: 25,
              Tgt_InitPos_m: 416.6667,
              Tgt_LatPos_m: 3.1,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "p0256500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 65,
              Obs1_InitPos_m: 439,
              Obs1_LatPos_m: -0.5,
              Obs2_InitPos_m: 0,
              Obs2_LatPos_m: -1.75,
              Overlap_per: 25,
              Tgt_InitPos_m: 443.0556,
              Tgt_LatPos_m: 3.1,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks:
              'No collision occurred.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "p0257000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 70,
              Obs1_InitPos_m: 465,
              Obs1_LatPos_m: -0.5,
              Obs2_InitPos_m: 0,
              Obs2_LatPos_m: -1.75,
              Overlap_per: 25,
              Tgt_InitPos_m: 469.4444,
              Tgt_LatPos_m: 3.1,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks:
              'No collision occurred.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "p0257500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 75,
              Obs1_InitPos_m: 491,
              Obs1_LatPos_m: -0.5,
              Obs2_InitPos_m: 0,
              Obs2_LatPos_m: -1.75,
              Overlap_per: 25,
              Tgt_InitPos_m: 495.8333,
              Tgt_LatPos_m: 3.1,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks:
              'No collision occurred.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "p0258000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 80,
              Obs1_InitPos_m: 518,
              Obs1_LatPos_m: -0.5,
              Obs2_InitPos_m: 0,
              Obs2_LatPos_m: -1.75,
              Overlap_per: 25,
              Tgt_InitPos_m: 522.2222,
              Tgt_LatPos_m: 3.1,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks:
              'No collision occurred.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "p0258500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 85,
              Obs1_InitPos_m: 544,
              Obs1_LatPos_m: -0.5,
              Obs2_InitPos_m: 0,
              Obs2_LatPos_m: -1.75,
              Overlap_per: 25,
              Tgt_InitPos_m: 548.6111,
              Tgt_LatPos_m: 3.1,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks:
              'No collision occurred.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "p0259000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 90,
              Obs1_InitPos_m: 571,
              Obs1_LatPos_m: -0.5,
              Obs2_InitPos_m: 0,
              Obs2_LatPos_m: -1.75,
              Overlap_per: 25,
              Tgt_InitPos_m: 575,
              Tgt_LatPos_m: 3.1,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks:
              'No collision occurred.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "p0259500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 95,
              Obs1_InitPos_m: 597,
              Obs1_LatPos_m: -0.5,
              Obs2_InitPos_m: 0,
              Obs2_LatPos_m: -1.75,
              Overlap_per: 25,
              Tgt_InitPos_m: 601.3888,
              Tgt_LatPos_m: 3.1,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1101HND142208",
            name: "p0259600-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 96,
              Obs1_InitPos_m: 602,
              Obs1_LatPos_m: -0.5,
              Obs2_InitPos_m: 0,
              Obs2_LatPos_m: -1.75,
              Overlap_per: 25,
              Tgt_InitPos_m: 606.6666,
              Tgt_LatPos_m: 3.1,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
        ],
      },
      {
        execution_id: "20240610142208",
        summary: {
          uuid: "1102CIS142208",
          Scenario: "1102CIS",
          Mandatory_Target: {
            Total_Variations_Executed: 1,
            Passed: 1,
            Failed: 0,
            Pass_Percentage: 100,
          },
          Development_Target: {
            Total_Variations_Executed: 1,
            Passed: 1,
            Failed: 0,
            Pass_Percentage: 100,
          },
        },
        variations: [
          {
            uuid: "1102CIS142208",
            name: "p1007200-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 72,
              Obs1_InitPos_m: 10,
              Obs1_LatPos_m: -1.35,
              Obs2_InitPos_m: 20,
              Obs2_LatPos_m: 4.75,
              Overlap_per: 100,
              Tgt_InitPos_m: 480,
              Tgt_LatPos_m: 1.75,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
        ],
      },
    ],
  },
  20240610142246: {
    test_execution_history: {
      Test_case_execution_id: "20240610142246",
      Model: "CS300",
      Execution: "Closed Loop",
      Executed_by: "Application",
      StartedAt: "2024-04-02 10:10:23",
      Mandatory_Target: {
        Total_Variations_Executed: 12,
        Passed: 3,
        Failed: 9,
        Pass_Percentage: "25.00%",
      },
      Development_Target: {
        Total_Variations_Executed: 12,
        Passed: 3,
        Failed: 9,
        Pass_Percentage: "25.00%",
      },
      Status: "Complete",
      Total_Scenarios_Executed: 2,
      Scenarios_Executed: ["1600HND", "1600HND_P160"],
    },
    test_summary: [
      {
        execution_id: "20240610142246",
        summary: {
          uuid: "1600HND142246",
          Scenario: "1600HND",
          Mandatory_Target: {
            Total_Variations_Executed: 11,
            Passed: 2,
            Failed: 9,
            Pass_Percentage: 18.18,
          },
          Development_Target: {
            Total_Variations_Executed: 11,
            Passed: 2,
            Failed: 9,
            Pass_Percentage: 18.18,
          },
        },
        variations: [
          {
            uuid: "1600HND142246",
            name: "p0501096-p090",
            InputParameters: {
              Curved_Buffer_m: 4.8,
              EV_ColPoint_m: 395.081,
              EV_InitPos_m: 356.1921,
              EV_InitSpd_Kmph: 10,
              EV_StartCond_m: 389,
              TTC_s: 4,
              Tgt_InitPos_m: 244.718820861678,
              Tgt_InitSpd_Kmph: 96,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1600HND142246",
            name: "p0501596-p090",
            InputParameters: {
              Curved_Buffer_m: 4.8,
              EV_ColPoint_m: 393.7666,
              EV_InitPos_m: 335.4327,
              EV_InitSpd_Kmph: 15,
              EV_StartCond_m: 384.5,
              TTC_s: 4,
              Tgt_InitPos_m: 253.718820861678,
              Tgt_InitSpd_Kmph: 96,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1600HND142246",
            name: "p0502096-p090",
            InputParameters: {
              Curved_Buffer_m: 4.8,
              EV_ColPoint_m: 392.6176,
              EV_InitPos_m: 315.166,
              EV_InitSpd_Kmph: 20,
              EV_StartCond_m: 381.5,
              TTC_s: 4,
              Tgt_InitPos_m: 256.452820861678,
              Tgt_InitSpd_Kmph: 96,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 14.77 sec.",
          },
          {
            uuid: "1600HND142246",
            name: "p0502530-p090",
            InputParameters: {
              Curved_Buffer_m: 4.18,
              EV_ColPoint_m: 395.081,
              EV_InitPos_m: 356.1921,
              EV_InitSpd_Kmph: 25,
              EV_StartCond_m: 389,
              TTC_s: 4,
              Tgt_InitPos_m: 358.95691609977325,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 6.25 sec.",
          },
          {
            uuid: "1600HND142246",
            name: "p0502545-p090",
            InputParameters: {
              Curved_Buffer_m: 5.2,
              EV_ColPoint_m: 395.081,
              EV_InitPos_m: 356.1921,
              EV_InitSpd_Kmph: 25,
              EV_StartCond_m: 389,
              TTC_s: 4,
              Tgt_InitPos_m: 339.02706122448984,
              Tgt_InitSpd_Kmph: 45,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 6.25 sec.",
          },
          {
            uuid: "1600HND142246",
            name: "p0502560-p090",
            InputParameters: {
              Curved_Buffer_m: 5.2,
              EV_ColPoint_m: 395.081,
              EV_InitPos_m: 356.1921,
              EV_InitSpd_Kmph: 25,
              EV_StartCond_m: 389,
              TTC_s: 4,
              Tgt_InitPos_m: 316.22896439909294,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 6.25 sec.",
          },
          {
            uuid: "1600HND142246",
            name: "p0502596-p090",
            InputParameters: {
              Curved_Buffer_m: 4.8,
              EV_ColPoint_m: 395.081,
              EV_InitPos_m: 356.1921,
              EV_InitSpd_Kmph: 25,
              EV_StartCond_m: 389,
              TTC_s: 4,
              Tgt_InitPos_m: 266.218820861678,
              Tgt_InitSpd_Kmph: 96,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 6.27 sec.",
          },
          {
            uuid: "1600HND142246",
            name: "p0503030-p090",
            InputParameters: {
              Curved_Buffer_m: 4.18,
              EV_ColPoint_m: 395.081,
              EV_InitPos_m: 356.1921,
              EV_InitSpd_Kmph: 30,
              EV_StartCond_m: 389,
              TTC_s: 4,
              Tgt_InitPos_m: 357.19091609977323,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 5.32 sec.",
          },
          {
            uuid: "1600HND142246",
            name: "p0503045-p090",
            InputParameters: {
              Curved_Buffer_m: 5.2,
              EV_ColPoint_m: 395.081,
              EV_InitPos_m: 356.1921,
              EV_InitSpd_Kmph: 30,
              EV_StartCond_m: 389,
              TTC_s: 4,
              Tgt_InitPos_m: 337.12806122448984,
              Tgt_InitSpd_Kmph: 45,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 5.34 sec.",
          },
          {
            uuid: "1600HND142246",
            name: "p0503060-p090",
            InputParameters: {
              Curved_Buffer_m: 5.2,
              EV_ColPoint_m: 395.081,
              EV_InitPos_m: 356.1921,
              EV_InitSpd_Kmph: 30,
              EV_StartCond_m: 389,
              TTC_s: 4,
              Tgt_InitPos_m: 321.22766439909293,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 5.34 sec.",
          },
          {
            uuid: "1600HND142246",
            name: "p0503096-p090",
            InputParameters: {
              Curved_Buffer_m: 4.8,
              EV_ColPoint_m: 395.081,
              EV_InitPos_m: 356.1921,
              EV_InitSpd_Kmph: 30,
              EV_StartCond_m: 389,
              TTC_s: 4,
              Tgt_InitPos_m: 290.718820861678,
              Tgt_InitSpd_Kmph: 96,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 5.32 sec.",
          },
        ],
      },
      {
        execution_id: "20240610142246",
        summary: {
          uuid: "1600HND_P160142246",
          Scenario: "1600HND_P160",
          Mandatory_Target: {
            Total_Variations_Executed: 1,
            Passed: 1,
            Failed: 0,
            Pass_Percentage: 100,
          },
          Development_Target: {
            Total_Variations_Executed: 1,
            Passed: 1,
            Failed: 0,
            Pass_Percentage: 100,
          },
        },
        variations: [
          {
            uuid: "1600HND_P160142246",
            name: "p0501030-p160",
            InputParameters: {
              EV_InitPos_m: 1940,
              EV_InitSpd_Kmph: 10,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "-".',
          },
        ],
      },
    ],
  },
  20240610142407: {
    test_execution_history: {
      Test_case_execution_id: "20240610142407",
      Model: "CS300",
      Execution: "Closed Loop",
      Executed_by: "Application",
      StartedAt: "2024-04-02 08:20:23",
      Mandatory_Target: {
        Total_Variations_Executed: 112,
        Passed: 112,
        Failed: 0,
        Pass_Percentage: "100.00%",
      },
      Development_Target: {
        Total_Variations_Executed: 112,
        Passed: 107,
        Failed: 5,
        Pass_Percentage: "95.54%",
      },
      Status: "Complete",
      Total_Scenarios_Executed: 4,
      Scenarios_Executed: ["1180HND", "1200CIS", "1200EUR", "1200HND"],
    },
    test_summary: [
      {
        execution_id: "20240610142407",
        summary: {
          uuid: "1180HND142407",
          Scenario: "1180HND",
          Mandatory_Target: {
            Total_Variations_Executed: 24,
            Passed: 24,
            Failed: 0,
            Pass_Percentage: 100,
          },
          Development_Target: {
            Total_Variations_Executed: 24,
            Passed: 24,
            Failed: 0,
            Pass_Percentage: 100,
          },
        },
        variations: [
          {
            uuid: "1180HND142407",
            name: "p0011000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 10,
              Tgt_CrashPoint_m: 1,
              Tgt_InitPos_m: 141.6667,
              Tgt_LatPos_m: -2.8371,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1180HND142407",
            name: "p0012000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 20,
              Tgt_CrashPoint_m: 1,
              Tgt_InitPos_m: 183.3333,
              Tgt_LatPos_m: -2.8371,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1180HND142407",
            name: "p0013000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 30,
              Tgt_CrashPoint_m: 1,
              Tgt_InitPos_m: 225,
              Tgt_LatPos_m: -2.8371,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1180HND142407",
            name: "p0014000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 40,
              Tgt_CrashPoint_m: 1,
              Tgt_InitPos_m: 266.6667,
              Tgt_LatPos_m: -2.8371,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1180HND142407",
            name: "p0015000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 50,
              Tgt_CrashPoint_m: 1,
              Tgt_InitPos_m: 308.3333,
              Tgt_LatPos_m: -2.8371,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1180HND142407",
            name: "p0016000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 60,
              Tgt_CrashPoint_m: 1,
              Tgt_InitPos_m: 350,
              Tgt_LatPos_m: -2.8371,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1180HND142407",
            name: "p0017000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 70,
              Tgt_CrashPoint_m: 1,
              Tgt_InitPos_m: 391.6667,
              Tgt_LatPos_m: -2.8371,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1180HND142407",
            name: "p0018000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 80,
              Tgt_CrashPoint_m: 1,
              Tgt_InitPos_m: 433.3333,
              Tgt_LatPos_m: -2.8371,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1180HND142407",
            name: "p0019000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 90,
              Tgt_CrashPoint_m: 1,
              Tgt_InitPos_m: 475,
              Tgt_LatPos_m: -2.8371,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1180HND142407",
            name: "p0019600-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 96,
              Tgt_CrashPoint_m: 1,
              Tgt_InitPos_m: 500,
              Tgt_LatPos_m: -2.8371,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1180HND142407",
            name: "p001A000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 100,
              Tgt_CrashPoint_m: 1,
              Tgt_InitPos_m: 516.6667,
              Tgt_LatPos_m: -2.8371,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1180HND142407",
            name: "p001B000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 110,
              Tgt_CrashPoint_m: 1,
              Tgt_InitPos_m: 558.3333,
              Tgt_LatPos_m: -2.8371,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1180HND142407",
            name: "p0p71000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 10,
              Tgt_CrashPoint_m: 0.75,
              Tgt_InitPos_m: 141.6667,
              Tgt_LatPos_m: -2.5871,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1180HND142407",
            name: "p0p72000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 20,
              Tgt_CrashPoint_m: 0.75,
              Tgt_InitPos_m: 183.3333,
              Tgt_LatPos_m: -2.5871,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1180HND142407",
            name: "p0p73000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 30,
              Tgt_CrashPoint_m: 0.75,
              Tgt_InitPos_m: 225,
              Tgt_LatPos_m: -2.5871,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1180HND142407",
            name: "p0p74000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 40,
              Tgt_CrashPoint_m: 0.75,
              Tgt_InitPos_m: 266.6667,
              Tgt_LatPos_m: -2.5871,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1180HND142407",
            name: "p0p75000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 50,
              Tgt_CrashPoint_m: 0.75,
              Tgt_InitPos_m: 308.3333,
              Tgt_LatPos_m: -2.5871,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1180HND142407",
            name: "p0p76000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 60,
              Tgt_CrashPoint_m: 0.75,
              Tgt_InitPos_m: 350,
              Tgt_LatPos_m: -2.5871,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1180HND142407",
            name: "p0p77000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 70,
              Tgt_CrashPoint_m: 0.75,
              Tgt_InitPos_m: 391.6667,
              Tgt_LatPos_m: -2.5871,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1180HND142407",
            name: "p0p78000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 80,
              Tgt_CrashPoint_m: 0.75,
              Tgt_InitPos_m: 433.3333,
              Tgt_LatPos_m: -2.5871,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1180HND142407",
            name: "p0p79000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 90,
              Tgt_CrashPoint_m: 0.75,
              Tgt_InitPos_m: 475,
              Tgt_LatPos_m: -2.5871,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1180HND142407",
            name: "p0p79600-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 96,
              Tgt_CrashPoint_m: 0.75,
              Tgt_InitPos_m: 500,
              Tgt_LatPos_m: -2.5871,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1180HND142407",
            name: "p0p7A000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 100,
              Tgt_CrashPoint_m: 0.75,
              Tgt_InitPos_m: 516.6667,
              Tgt_LatPos_m: -2.5871,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1180HND142407",
            name: "p0p7B000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 110,
              Tgt_CrashPoint_m: 0.75,
              Tgt_InitPos_m: 558.3333,
              Tgt_LatPos_m: -2.5871,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
        ],
      },
      {
        execution_id: "20240610142407",
        summary: {
          uuid: "1200CIS142407",
          Scenario: "1200CIS",
          Mandatory_Target: {
            Total_Variations_Executed: 2,
            Passed: 2,
            Failed: 0,
            Pass_Percentage: 100,
          },
          Development_Target: {
            Total_Variations_Executed: 2,
            Passed: 2,
            Failed: 0,
            Pass_Percentage: 100,
          },
        },
        variations: [
          {
            uuid: "1200CIS142407",
            name: "p1005020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 50,
              Overlap_per: 100,
              Tgt_InitPos_m: 406.75529604434365,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 1.75,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200CIS142407",
            name: "p1007020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 100,
              Tgt_InitPos_m: 470.08529604434369,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 1.75,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
        ],
      },
      {
        execution_id: "20240610142407",
        summary: {
          uuid: "1200EUR142407",
          Scenario: "1200EUR",
          Mandatory_Target: {
            Total_Variations_Executed: 66,
            Passed: 66,
            Failed: 0,
            Pass_Percentage: 100,
          },
          Development_Target: {
            Total_Variations_Executed: 66,
            Passed: 61,
            Failed: 5,
            Pass_Percentage: 92.42,
          },
        },
        variations: [
          {
            uuid: "1200EUR142407",
            name: "n0503020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 30,
              Overlap_per: -50,
              Tgt_InitPos_m: 209.53639604434366,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 2.65,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "n0503520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 35,
              Overlap_per: -50,
              Tgt_InitPos_m: 237.31419604434367,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 2.65,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "n0504020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 40,
              Overlap_per: -50,
              Tgt_InitPos_m: 265.09199604434366,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 2.65,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "n0504520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 45,
              Overlap_per: -50,
              Tgt_InitPos_m: 292.86969604434364,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 2.65,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "n0505020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 50,
              Overlap_per: -50,
              Tgt_InitPos_m: 320.64749604434365,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 2.65,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "n0505520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 55,
              Overlap_per: -50,
              Tgt_InitPos_m: 348.42529604434367,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 2.65,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "n0506020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 60,
              Overlap_per: -50,
              Tgt_InitPos_m: 376.20309604434368,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 2.65,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "n0506520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 65,
              Overlap_per: -50,
              Tgt_InitPos_m: 403.98089604434369,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 2.65,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "n0507020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 70,
              Overlap_per: -50,
              Tgt_InitPos_m: 431.75859604434368,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 2.65,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "n0507520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 75,
              Overlap_per: -50,
              Tgt_InitPos_m: 459.53639604434369,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 2.65,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "n0508020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 80,
              Overlap_per: -50,
              Tgt_InitPos_m: 487.31419604434365,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 2.65,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 20.22 sec.",
          },
          {
            uuid: "1200EUR142407",
            name: "n0753020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 30,
              Overlap_per: -75,
              Tgt_InitPos_m: 209.53639604434366,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 2.21,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "n0753520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 35,
              Overlap_per: -75,
              Tgt_InitPos_m: 237.31419604434367,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 2.21,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "n0754020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 40,
              Overlap_per: -75,
              Tgt_InitPos_m: 265.09199604434366,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 2.21,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "n0754520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 45,
              Overlap_per: -75,
              Tgt_InitPos_m: 292.86969604434364,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 2.21,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "n0755020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 50,
              Overlap_per: -75,
              Tgt_InitPos_m: 320.64749604434365,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 2.21,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "n0755520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 55,
              Overlap_per: -75,
              Tgt_InitPos_m: 348.42529604434367,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 2.21,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "n0756020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 60,
              Overlap_per: -75,
              Tgt_InitPos_m: 376.20309604434368,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 2.21,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "n0756520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 65,
              Overlap_per: -75,
              Tgt_InitPos_m: 403.98089604434369,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 2.21,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "n0757020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 70,
              Overlap_per: -75,
              Tgt_InitPos_m: 431.75859604434368,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 2.21,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "n0757520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 75,
              Overlap_per: -75,
              Tgt_InitPos_m: 459.53639604434369,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 2.21,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "n0758020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 80,
              Overlap_per: -75,
              Tgt_InitPos_m: 487.31419604434365,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 2.21,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 20.22 sec.",
          },
          {
            uuid: "1200EUR142407",
            name: "p0253020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 30,
              Overlap_per: 25,
              Tgt_InitPos_m: 209.53639604434366,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.6,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1200EUR142407",
            name: "p0253520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 35,
              Overlap_per: 25,
              Tgt_InitPos_m: 237.31419604434367,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.6,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1200EUR142407",
            name: "p0254020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 40,
              Overlap_per: 25,
              Tgt_InitPos_m: 265.09199604434366,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.6,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1200EUR142407",
            name: "p0254520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 45,
              Overlap_per: 25,
              Tgt_InitPos_m: 292.86969604434364,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.6,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1200EUR142407",
            name: "p0255020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 50,
              Overlap_per: 25,
              Tgt_InitPos_m: 320.64749604434365,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.6,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1200EUR142407",
            name: "p0255520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 55,
              Overlap_per: 25,
              Tgt_InitPos_m: 348.42529604434367,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.6,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1200EUR142407",
            name: "p0256020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 60,
              Overlap_per: 25,
              Tgt_InitPos_m: 376.20309604434368,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.6,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1200EUR142407",
            name: "p0256520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 65,
              Overlap_per: 25,
              Tgt_InitPos_m: 403.98089604434369,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.6,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1200EUR142407",
            name: "p0257020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 25,
              Tgt_InitPos_m: 431.75859604434368,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.6,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1200EUR142407",
            name: "p0257520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 75,
              Overlap_per: 25,
              Tgt_InitPos_m: 459.53639604434369,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.6,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1200EUR142407",
            name: "p0258020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 80,
              Overlap_per: 25,
              Tgt_InitPos_m: 487.31419604434365,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.6,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1200EUR142407",
            name: "p0503020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 30,
              Overlap_per: 50,
              Tgt_InitPos_m: 209.53639604434366,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.9,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "p0503520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 35,
              Overlap_per: 50,
              Tgt_InitPos_m: 237.31419604434367,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.9,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "p0504020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 40,
              Overlap_per: 50,
              Tgt_InitPos_m: 265.09199604434366,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.9,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "p0504520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 45,
              Overlap_per: 50,
              Tgt_InitPos_m: 292.86969604434364,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.9,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "p0505020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 50,
              Overlap_per: 50,
              Tgt_InitPos_m: 320.64749604434365,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.9,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "p0505520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 55,
              Overlap_per: 50,
              Tgt_InitPos_m: 348.42529604434367,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.9,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "p0506020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 60,
              Overlap_per: 50,
              Tgt_InitPos_m: 376.20309604434368,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.9,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "p0506520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 65,
              Overlap_per: 50,
              Tgt_InitPos_m: 403.98089604434369,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.9,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "p0507020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 50,
              Tgt_InitPos_m: 431.75859604434368,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.9,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "p0507520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 75,
              Overlap_per: 50,
              Tgt_InitPos_m: 459.53639604434369,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.9,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "p0508020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 80,
              Overlap_per: 50,
              Tgt_InitPos_m: 487.31419604434365,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.9,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 20.22 sec.",
          },
          {
            uuid: "1200EUR142407",
            name: "p0753020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 30,
              Overlap_per: 75,
              Tgt_InitPos_m: 209.53639604434366,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 1.28,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "p0753520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 35,
              Overlap_per: 75,
              Tgt_InitPos_m: 237.31419604434367,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 1.28,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "p0754020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 40,
              Overlap_per: 75,
              Tgt_InitPos_m: 265.09199604434366,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 1.28,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "p0754520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 45,
              Overlap_per: 75,
              Tgt_InitPos_m: 292.86969604434364,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 1.28,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "p0755020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 50,
              Overlap_per: 75,
              Tgt_InitPos_m: 320.64749604434365,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 1.28,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "p0755520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 55,
              Overlap_per: 75,
              Tgt_InitPos_m: 348.42529604434367,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 1.28,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "p0756020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 60,
              Overlap_per: 75,
              Tgt_InitPos_m: 376.20309604434368,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 1.28,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "p0756520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 65,
              Overlap_per: 75,
              Tgt_InitPos_m: 403.98089604434369,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 1.28,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "p0757020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 75,
              Tgt_InitPos_m: 431.75859604434368,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 1.28,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "p0757520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 75,
              Overlap_per: 75,
              Tgt_InitPos_m: 459.53639604434369,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 1.28,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "p0758020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 80,
              Overlap_per: 75,
              Tgt_InitPos_m: 487.31419604434365,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 1.28,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 20.22 sec.",
          },
          {
            uuid: "1200EUR142407",
            name: "p1003020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 30,
              Overlap_per: 100,
              Tgt_InitPos_m: 209.53639604434366,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 1.75,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "p1003520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 35,
              Overlap_per: 100,
              Tgt_InitPos_m: 237.31419604434367,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 1.75,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "p1004020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 40,
              Overlap_per: 100,
              Tgt_InitPos_m: 265.09199604434366,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 1.75,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "p1004520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 45,
              Overlap_per: 100,
              Tgt_InitPos_m: 292.86969604434364,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 1.75,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "p1005020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 50,
              Overlap_per: 100,
              Tgt_InitPos_m: 320.64749604434365,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 1.75,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "p1005520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 55,
              Overlap_per: 100,
              Tgt_InitPos_m: 348.42529604434367,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 1.75,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "p1006020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 60,
              Overlap_per: 100,
              Tgt_InitPos_m: 376.20309604434368,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 1.75,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "p1006520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 65,
              Overlap_per: 100,
              Tgt_InitPos_m: 403.98089604434369,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 1.75,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "p1007020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 100,
              Tgt_InitPos_m: 431.75859604434368,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 1.75,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "p1007520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 75,
              Overlap_per: 100,
              Tgt_InitPos_m: 459.53639604434369,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 1.75,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200EUR142407",
            name: "p1008020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 80,
              Overlap_per: 100,
              Tgt_InitPos_m: 487.31419604434365,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 1.75,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 20.22 sec.",
          },
        ],
      },
      {
        execution_id: "20240610142407",
        summary: {
          uuid: "1200HND142407",
          Scenario: "1200HND",
          Mandatory_Target: {
            Total_Variations_Executed: 20,
            Passed: 20,
            Failed: 0,
            Pass_Percentage: 100,
          },
          Development_Target: {
            Total_Variations_Executed: 20,
            Passed: 20,
            Failed: 0,
            Pass_Percentage: 100,
          },
        },
        variations: [
          {
            uuid: "1200HND142407",
            name: "n0508520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 85,
              Overlap_per: -50,
              Tgt_InitPos_m: 515.09199604434366,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1200HND142407",
            name: "n0509020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 90,
              Overlap_per: -50,
              Tgt_InitPos_m: 542.86969604434364,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1200HND142407",
            name: "n0509520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 95,
              Overlap_per: -50,
              Tgt_InitPos_m: 570.64749604434371,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1200HND142407",
            name: "n0509620-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 96,
              Overlap_per: -50,
              Tgt_InitPos_m: 576.20309604434362,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1200HND142407",
            name: "n0758520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 85,
              Overlap_per: -75,
              Tgt_InitPos_m: 515.09199604434366,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1200HND142407",
            name: "n0759020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 90,
              Overlap_per: -75,
              Tgt_InitPos_m: 542.86969604434364,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1200HND142407",
            name: "n0759520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 95,
              Overlap_per: -75,
              Tgt_InitPos_m: 570.64749604434371,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1200HND142407",
            name: "n0759620-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 96,
              Overlap_per: -75,
              Tgt_InitPos_m: 576.20309604434362,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1200HND142407",
            name: "p0508520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 85,
              Overlap_per: 50,
              Tgt_InitPos_m: 515.09199604434366,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1200HND142407",
            name: "p0509020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 90,
              Overlap_per: 50,
              Tgt_InitPos_m: 542.86969604434364,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1200HND142407",
            name: "p0509520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 95,
              Overlap_per: 50,
              Tgt_InitPos_m: 570.64749604434371,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1200HND142407",
            name: "p0509620-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 96,
              Overlap_per: 50,
              Tgt_InitPos_m: 576.20309604434362,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1200HND142407",
            name: "p0758520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 85,
              Overlap_per: 75,
              Tgt_InitPos_m: 515.09199604434366,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1200HND142407",
            name: "p0759020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 90,
              Overlap_per: 75,
              Tgt_InitPos_m: 542.86969604434364,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1200HND142407",
            name: "p0759520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 95,
              Overlap_per: 75,
              Tgt_InitPos_m: 570.64749604434371,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1200HND142407",
            name: "p0759620-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 96,
              Overlap_per: 75,
              Tgt_InitPos_m: 576.20309604434362,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1200HND142407",
            name: "p1008520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 85,
              Overlap_per: 100,
              Tgt_InitPos_m: 515.09199604434366,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1200HND142407",
            name: "p1009020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 90,
              Overlap_per: 100,
              Tgt_InitPos_m: 542.86969604434364,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1200HND142407",
            name: "p1009520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 95,
              Overlap_per: 100,
              Tgt_InitPos_m: 570.64749604434371,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1200HND142407",
            name: "p1009620-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 96,
              Overlap_per: 100,
              Tgt_InitPos_m: 576.20309604434362,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
        ],
      },
    ],
  },
  20240610142512: {
    test_execution_history: {
      Test_case_execution_id: "20240610142512",
      Model: "CS300",
      Execution: "Closed Loop",
      Executed_by: "Application",
      StartedAt: "2024-03-02 08:10:43",
      Mandatory_Target: {
        Total_Variations_Executed: 52,
        Passed: 52,
        Failed: 0,
        Pass_Percentage: "100.00%",
      },
      Development_Target: {
        Total_Variations_Executed: 52,
        Passed: 46,
        Failed: 0,
        Pass_Percentage: "88.46%",
      },
      Status: "Complete",
      Total_Scenarios_Executed: 3,
      Scenarios_Executed: ["1201HND", "1204HND", "1280HND"],
    },
    test_summary: [
      {
        execution_id: "20240610142512",
        summary: {
          uuid: "1201HND142512",
          Scenario: "1201HND",
          Mandatory_Target: {
            Total_Variations_Executed: 19,
            Passed: 19,
            Failed: 0,
            Pass_Percentage: 100,
          },
          Development_Target: {
            Total_Variations_Executed: 19,
            Passed: 19,
            Failed: 0,
            Pass_Percentage: 100,
          },
        },
        variations: [
          {
            uuid: "1201HND142512",
            name: "n0253020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 30,
              Obs1_InitPos_m: 272,
              Obs1_LatPos_m: 2.4,
              Obs2_InitPos_m: 270,
              Obs2_LatPos_m: -1.75,
              Overlap_per: -25,
              Tgt_InitPos_m: 209.53639604434366,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.4,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1201HND142512",
            name: "n0253520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 35,
              Obs1_InitPos_m: 298,
              Obs1_LatPos_m: 2.4,
              Obs2_InitPos_m: 300,
              Obs2_LatPos_m: -1.75,
              Overlap_per: -25,
              Tgt_InitPos_m: 237.31419604434367,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.4,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1201HND142512",
            name: "n0254020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 40,
              Obs1_InitPos_m: 326,
              Obs1_LatPos_m: 2.4,
              Obs2_InitPos_m: 330,
              Obs2_LatPos_m: -1.75,
              Overlap_per: -25,
              Tgt_InitPos_m: 265.09199604434366,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.4,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1201HND142512",
            name: "n0254520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 45,
              Obs1_InitPos_m: 353,
              Obs1_LatPos_m: 2.4,
              Obs2_InitPos_m: 356,
              Obs2_LatPos_m: -1.75,
              Overlap_per: -25,
              Tgt_InitPos_m: 292.86969604434364,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.4,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1201HND142512",
            name: "n0255020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 50,
              Obs1_InitPos_m: 381,
              Obs1_LatPos_m: 2.4,
              Obs2_InitPos_m: 382,
              Obs2_LatPos_m: -1.75,
              Overlap_per: -25,
              Tgt_InitPos_m: 320.64749604434365,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.4,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1201HND142512",
            name: "n0255520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 55,
              Obs1_InitPos_m: 409,
              Obs1_LatPos_m: 2.4,
              Obs2_InitPos_m: 408,
              Obs2_LatPos_m: -1.75,
              Overlap_per: -25,
              Tgt_InitPos_m: 348.42529604434367,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.4,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1201HND142512",
            name: "n0256020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 60,
              Obs1_InitPos_m: 437,
              Obs1_LatPos_m: 2.4,
              Obs2_InitPos_m: 436,
              Obs2_LatPos_m: -1.75,
              Overlap_per: -25,
              Tgt_InitPos_m: 376.20309604434368,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.4,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1201HND142512",
            name: "n0256520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 65,
              Obs1_InitPos_m: 464,
              Obs1_LatPos_m: 2.4,
              Obs2_InitPos_m: 463,
              Obs2_LatPos_m: -1.75,
              Overlap_per: -25,
              Tgt_InitPos_m: 403.98089604434369,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.4,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1201HND142512",
            name: "n0257020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 70,
              Obs1_InitPos_m: 492,
              Obs1_LatPos_m: 2.4,
              Obs2_InitPos_m: 491,
              Obs2_LatPos_m: -1.75,
              Overlap_per: -25,
              Tgt_InitPos_m: 431.75859604434368,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.4,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1201HND142512",
            name: "n0257520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 75,
              Obs1_InitPos_m: 520,
              Obs1_LatPos_m: 2.4,
              Obs2_InitPos_m: 519,
              Obs2_LatPos_m: -1.75,
              Overlap_per: -25,
              Tgt_InitPos_m: 459.53639604434369,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.4,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1201HND142512",
            name: "n0258020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 80,
              Obs1_InitPos_m: 548,
              Obs1_LatPos_m: 2.4,
              Obs2_InitPos_m: 547,
              Obs2_LatPos_m: -1.75,
              Overlap_per: -25,
              Tgt_InitPos_m: 487.31419604434365,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.4,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks:
              'No collision occurred.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1201HND142512",
            name: "n0258520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 85,
              Obs1_InitPos_m: 551,
              Obs1_LatPos_m: 2.4,
              Obs2_InitPos_m: 550,
              Obs2_LatPos_m: -1.75,
              Overlap_per: -25,
              Tgt_InitPos_m: 515.09199604434366,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.4,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks:
              'No collision occurred.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1201HND142512",
            name: "n0259020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 90,
              Obs1_InitPos_m: 603,
              Obs1_LatPos_m: 2.4,
              Obs2_InitPos_m: 602,
              Obs2_LatPos_m: -1.75,
              Overlap_per: -25,
              Tgt_InitPos_m: 542.86969604434364,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.4,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks:
              'No collision occurred.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1201HND142512",
            name: "n0259520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 95,
              Obs1_InitPos_m: 631,
              Obs1_LatPos_m: 2.4,
              Obs2_InitPos_m: 630,
              Obs2_LatPos_m: -1.75,
              Overlap_per: -25,
              Tgt_InitPos_m: 570.64749604434371,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.4,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks:
              'No collision occurred.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1201HND142512",
            name: "n0259620-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 96,
              Obs1_InitPos_m: 637,
              Obs1_LatPos_m: 2.4,
              Obs2_InitPos_m: 636,
              Obs2_LatPos_m: -1.75,
              Overlap_per: -25,
              Tgt_InitPos_m: 576.20299604434365,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 0.4,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks:
              'No collision occurred.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1201HND142512",
            name: "p0258520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 85,
              Obs1_InitPos_m: 620,
              Obs1_LatPos_m: 2.4,
              Obs2_InitPos_m: 576,
              Obs2_LatPos_m: -0.6,
              Overlap_per: 25,
              Tgt_InitPos_m: 515.09199604434366,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 3.1,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks:
              'No collision occurred.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1201HND142512",
            name: "p0259020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 90,
              Obs1_InitPos_m: 650,
              Obs1_LatPos_m: 2.4,
              Obs2_InitPos_m: 603,
              Obs2_LatPos_m: -0.6,
              Overlap_per: 25,
              Tgt_InitPos_m: 542.86969604434364,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 3.1,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks:
              'No collision occurred.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1201HND142512",
            name: "p0259520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 95,
              Obs1_InitPos_m: 680,
              Obs1_LatPos_m: 2.4,
              Obs2_InitPos_m: 631,
              Obs2_LatPos_m: -0.6,
              Overlap_per: 25,
              Tgt_InitPos_m: 570.64749604434371,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 3.1,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks:
              'No collision occurred.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1201HND142512",
            name: "p0259620-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 96,
              Obs1_InitPos_m: 710,
              Obs1_LatPos_m: 2.4,
              Obs2_InitPos_m: 637,
              Obs2_LatPos_m: -0.6,
              Overlap_per: 25,
              Tgt_InitPos_m: 576.20299604434365,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 3.1,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks:
              'No collision occurred.\n\nNot tested for KPI "No requirement".',
          },
        ],
      },
      {
        execution_id: "20240610142512",
        summary: {
          uuid: "1204HND142512",
          Scenario: "1204HND",
          Mandatory_Target: {
            Total_Variations_Executed: 9,
            Passed: 9,
            Failed: 0,
            Pass_Percentage: 100,
          },
          Development_Target: {
            Total_Variations_Executed: 9,
            Passed: 3,
            Failed: 0,
            Pass_Percentage: 33.33,
          },
        },
        variations: [
          {
            uuid: "1204HND142512",
            name: "p0253029-p000_1204",
            InputParameters: {
              EV_FinalSpd_Kmph: 30,
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 29,
              Overlap_per: 25,
              Tgt_InitPos_m: 513.40366105757118,
              Tgt_InitSpd_Kmph: 28.79,
              Tgt_LatPos_m: 3.12,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1204HND142512",
            name: "p0256059-p000_1204",
            InputParameters: {
              EV_FinalSpd_Kmph: 60,
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 59,
              Overlap_per: 25,
              Tgt_InitPos_m: 286.39351812484256,
              Tgt_InitSpd_Kmph: 58.79,
              Tgt_LatPos_m: 3.12,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1204HND142512",
            name: "p025C0B9-p000_1204",
            InputParameters: {
              EV_FinalSpd_Kmph: 120,
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 119,
              Overlap_per: 25,
              Tgt_InitPos_m: 394.44812885802469,
              Tgt_InitSpd_Kmph: 118.79,
              Tgt_LatPos_m: 3.12,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1204HND142512",
            name: "p0503029-p000_1204",
            InputParameters: {
              EV_FinalSpd_Kmph: 30,
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 29,
              Overlap_per: 50,
              Tgt_InitPos_m: 513.40366105757118,
              Tgt_InitSpd_Kmph: 28.79,
              Tgt_LatPos_m: 2.66,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "ERROR" },
            Remarks: 'Not tested for KPI "No requirement".\n\nSignal missing!',
          },
          {
            uuid: "1204HND142512",
            name: "p0506059-p000_1204",
            InputParameters: {
              EV_FinalSpd_Kmph: 60,
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 59,
              Overlap_per: 50,
              Tgt_InitPos_m: 286.39351812484256,
              Tgt_InitSpd_Kmph: 58.79,
              Tgt_LatPos_m: 2.66,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "ERROR" },
            Remarks: 'Not tested for KPI "No requirement".\n\nSignal missing!',
          },
          {
            uuid: "1204HND142512",
            name: "p050C0B9-p000_1204",
            InputParameters: {
              EV_FinalSpd_Kmph: 120,
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 119,
              Overlap_per: 50,
              Tgt_InitPos_m: 394.47618417737465,
              Tgt_InitSpd_Kmph: 118.76,
              Tgt_LatPos_m: 2.66,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "ERROR" },
            Remarks: 'Not tested for KPI "No requirement".\n\nSignal missing!',
          },
          {
            uuid: "1204HND142512",
            name: "p1003029-p000",
            InputParameters: {
              EV_FinalSpd_Kmph: 30,
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 29,
              Overlap_per: 100,
              Tgt_InitPos_m: 513.40366105757118,
              Tgt_InitSpd_Kmph: 28.79,
              Tgt_LatPos_m: 1.75,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "ERROR" },
            Remarks: 'Not tested for KPI "No requirement".\n\nSignal missing!',
          },
          {
            uuid: "1204HND142512",
            name: "p1006059-p000",
            InputParameters: {
              EV_FinalSpd_Kmph: 60,
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 59,
              Overlap_per: 100,
              Tgt_InitPos_m: 282.39351812484256,
              Tgt_InitSpd_Kmph: 58.79,
              Tgt_LatPos_m: 1.75,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "ERROR" },
            Remarks: 'Not tested for KPI "No requirement".\n\nSignal missing!',
          },
          {
            uuid: "1204HND142512",
            name: "p100C0B9-p000",
            InputParameters: {
              EV_FinalSpd_Kmph: 120,
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 119,
              Overlap_per: 100,
              Tgt_InitPos_m: 394.44812885802469,
              Tgt_InitSpd_Kmph: 118.79,
              Tgt_LatPos_m: 1.75,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "ERROR" },
            Remarks: 'Not tested for KPI "No requirement".\n\nSignal missing!',
          },
        ],
      },
      {
        execution_id: "20240610142512",
        summary: {
          uuid: "1280HND142512",
          Scenario: "1280HND",
          Mandatory_Target: {
            Total_Variations_Executed: 24,
            Passed: 24,
            Failed: 0,
            Pass_Percentage: 100,
          },
          Development_Target: {
            Total_Variations_Executed: 24,
            Passed: 24,
            Failed: 0,
            Pass_Percentage: 100,
          },
        },
        variations: [
          {
            uuid: "1280HND142512",
            name: "p0013020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 30,
              Tgt_CrashPoint_m: 1,
              Tgt_InitPos_m: 223.42529604434367,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: -2.8371,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1280HND142512",
            name: "p0014020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 40,
              Tgt_CrashPoint_m: 1,
              Tgt_InitPos_m: 265.09199604434366,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: -2.8371,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1280HND142512",
            name: "p0015020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 50,
              Tgt_CrashPoint_m: 1,
              Tgt_InitPos_m: 306.75859604434368,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: -2.8371,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1280HND142512",
            name: "p0016020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 60,
              Tgt_CrashPoint_m: 1,
              Tgt_InitPos_m: 348.42529604434367,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: -2.8371,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1280HND142512",
            name: "p0017020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 70,
              Tgt_CrashPoint_m: 1,
              Tgt_InitPos_m: 390.09199604434366,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: -2.8371,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1280HND142512",
            name: "p0018020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 80,
              Tgt_CrashPoint_m: 1,
              Tgt_InitPos_m: 431.75859604434368,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: -2.8371,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1280HND142512",
            name: "p0019020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 90,
              Tgt_CrashPoint_m: 1,
              Tgt_InitPos_m: 473.42529604434367,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: -2.8371,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1280HND142512",
            name: "p0019620-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 96,
              Tgt_CrashPoint_m: 1,
              Tgt_InitPos_m: 498.42529604434367,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: -2.8371,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1280HND142512",
            name: "p001A020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 100,
              Tgt_CrashPoint_m: 1,
              Tgt_InitPos_m: 515.09199604434366,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: -2.8371,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1280HND142512",
            name: "p001B020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 110,
              Tgt_CrashPoint_m: 1,
              Tgt_InitPos_m: 556.75859604434368,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: -2.8371,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1280HND142512",
            name: "p001C020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 120,
              Tgt_CrashPoint_m: 1,
              Tgt_InitPos_m: 598.42529604434367,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: -2.8371,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1280HND142512",
            name: "p001D020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 130,
              Tgt_CrashPoint_m: 1,
              Tgt_InitPos_m: 640.09199604434366,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: -2.8371,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1280HND142512",
            name: "p0p73020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 30,
              Tgt_CrashPoint_m: 0.75,
              Tgt_InitPos_m: 223.42529604434367,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: -2.5871,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1280HND142512",
            name: "p0p74020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 40,
              Tgt_CrashPoint_m: 0.75,
              Tgt_InitPos_m: 265.09199604434366,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: -2.5871,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1280HND142512",
            name: "p0p75020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 50,
              Tgt_CrashPoint_m: 0.75,
              Tgt_InitPos_m: 306.75859604434368,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: -2.5871,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1280HND142512",
            name: "p0p76020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 60,
              Tgt_CrashPoint_m: 0.75,
              Tgt_InitPos_m: 348.42529604434367,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: -2.5871,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1280HND142512",
            name: "p0p77020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 70,
              Tgt_CrashPoint_m: 0.75,
              Tgt_InitPos_m: 390.09199604434366,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: -2.5871,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1280HND142512",
            name: "p0p78020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 80,
              Tgt_CrashPoint_m: 0.75,
              Tgt_InitPos_m: 431.75859604434368,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: -2.5871,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1280HND142512",
            name: "p0p79020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 90,
              Tgt_CrashPoint_m: 0.75,
              Tgt_InitPos_m: 473.42529604434367,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: -2.5871,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1280HND142512",
            name: "p0p79620-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 96,
              Tgt_CrashPoint_m: 0.75,
              Tgt_InitPos_m: 498.42529604434367,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: -2.5871,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1280HND142512",
            name: "p0p7A020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 100,
              Tgt_CrashPoint_m: 0.75,
              Tgt_InitPos_m: 515.09199604434366,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: -2.5871,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1280HND142512",
            name: "p0p7B020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 110,
              Tgt_CrashPoint_m: 0.75,
              Tgt_InitPos_m: 556.75859604434368,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: -2.5871,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1280HND142512",
            name: "p0p7C020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 120,
              Tgt_CrashPoint_m: 0.75,
              Tgt_InitPos_m: 598.42529604434367,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: -2.5871,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1280HND142512",
            name: "p0p7D020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 130,
              Tgt_CrashPoint_m: 0.75,
              Tgt_InitPos_m: 640.09199604434366,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: -2.5871,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
        ],
      },
    ],
  },
  20240610142742: {
    test_execution_history: {
      Test_case_execution_id: "20240610142742",
      Model: "CS300",
      Execution: "Closed Loop",
      Executed_by: "Application",
      StartedAt: "2024-02-02 10:10:23",
      Mandatory_Target: {
        Total_Variations_Executed: 223,
        Passed: 128,
        Failed: 95,
        Pass_Percentage: "57.40%",
      },
      Development_Target: {
        Total_Variations_Executed: 223,
        Passed: 71,
        Failed: 152,
        Pass_Percentage: "31.84%",
      },
      Status: "Complete",
      Total_Scenarios_Executed: 5,
      Scenarios_Executed: [
        "1280HND_HA2",
        "1400EUR",
        "1400HND",
        "1400HND_LC",
        "1500EUR",
      ],
    },
    test_summary: [
      {
        execution_id: "20240610142742",
        summary: {
          uuid: "1280HND_HA2142742",
          Scenario: "1280HND_HA2",
          Mandatory_Target: {
            Total_Variations_Executed: 3,
            Passed: 3,
            Failed: 0,
            Pass_Percentage: 100,
          },
          Development_Target: {
            Total_Variations_Executed: 3,
            Passed: 3,
            Failed: 0,
            Pass_Percentage: 100,
          },
        },
        variations: [
          {
            uuid: "1280HND_HA2142742",
            name: "p0033030-p000",
            InputParameters: {
              Closest_Dist_m: 30,
              Duration1_sec: 2.7,
              Duration2_sec: 5.7,
              EV_FinalSpd_Kmph: 30,
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 30,
              Gas_G: 0.1476,
              Overlap_per: 100,
              Tgt_InitPos_m: 216.45691609977325,
              Tgt_InitSpd_Kmph: 30,
              Tgt_LatPos_m: 0,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1280HND_HA2142742",
            name: "p10pC0C0-p000",
            InputParameters: {
              Closest_Dist_m: 30,
              Duration1_sec: 3.5,
              Duration2_sec: 6.5,
              EV_FinalSpd_Kmph: 120,
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 120,
              Gas_G: 0.36,
              Overlap_per: 100,
              Tgt_InitPos_m: 643.31065759637193,
              Tgt_InitSpd_Kmph: 120,
              Tgt_LatPos_m: 0,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1280HND_HA2142742",
            name: "p5p56060-p000",
            InputParameters: {
              Closest_Dist_m: 30,
              Duration1_sec: 2.9,
              Duration2_sec: 5.9,
              EV_FinalSpd_Kmph: 60,
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 60,
              Gas_G: 0.184,
              Overlap_per: 100,
              Tgt_InitPos_m: 285.82766439909295,
              Tgt_InitSpd_Kmph: 60,
              Tgt_LatPos_m: 0,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
        ],
      },
      {
        execution_id: "20240610142742",
        summary: {
          uuid: "1400EUR142742",
          Scenario: "1400EUR",
          Mandatory_Target: {
            Total_Variations_Executed: 25,
            Passed: 13,
            Failed: 12,
            Pass_Percentage: 52,
          },
          Development_Target: {
            Total_Variations_Executed: 25,
            Passed: 13,
            Failed: 12,
            Pass_Percentage: 52,
          },
        },
        variations: [
          {
            uuid: "1400EUR142742",
            name: "p0252020-p090",
            InputParameters: {
              EV_InitPos_m: 891.8244,
              EV_InitSpd_Kmph: 20,
              Overlap_per: 25,
              Tgt_InitPos_m: 974.95309604434362,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400EUR142742",
            name: "p0252030-p090",
            InputParameters: {
              EV_InitPos_m: 891.8244,
              EV_InitSpd_Kmph: 20,
              Overlap_per: 25,
              Tgt_InitPos_m: 961.87361609977324,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400EUR142742",
            name: "p0252040-p090",
            InputParameters: {
              EV_InitPos_m: 891.8244,
              EV_InitSpd_Kmph: 20,
              Overlap_per: 25,
              Tgt_InitPos_m: 948.0067841773747,
              Tgt_InitSpd_Kmph: 40,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400EUR142742",
            name: "p0252050-p090",
            InputParameters: {
              EV_InitPos_m: 891.8244,
              EV_InitSpd_Kmph: 20,
              Overlap_per: 25,
              Tgt_InitPos_m: 933.3525002771479,
              Tgt_InitSpd_Kmph: 50,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400EUR142742",
            name: "p0252060-p090",
            InputParameters: {
              EV_InitPos_m: 891.8244,
              EV_InitSpd_Kmph: 20,
              Overlap_per: 25,
              Tgt_InitPos_m: 917.910964399093,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400EUR142742",
            name: "p0253020-p090",
            InputParameters: {
              EV_InitPos_m: 839.0467,
              EV_InitSpd_Kmph: 30,
              Overlap_per: 25,
              Tgt_InitPos_m: 974.95309604434362,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400EUR142742",
            name: "p0253030-p090",
            InputParameters: {
              EV_InitPos_m: 839.0467,
              EV_InitSpd_Kmph: 30,
              Overlap_per: 25,
              Tgt_InitPos_m: 961.87361609977324,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400EUR142742",
            name: "p0253040-p090",
            InputParameters: {
              EV_InitPos_m: 839.0467,
              EV_InitSpd_Kmph: 30,
              Overlap_per: 25,
              Tgt_InitPos_m: 948.0067841773747,
              Tgt_InitSpd_Kmph: 40,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400EUR142742",
            name: "p0253050-p090",
            InputParameters: {
              EV_InitPos_m: 839.0467,
              EV_InitSpd_Kmph: 30,
              Overlap_per: 25,
              Tgt_InitPos_m: 933.3525002771479,
              Tgt_InitSpd_Kmph: 50,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400EUR142742",
            name: "p0253060-p090",
            InputParameters: {
              EV_InitPos_m: 839.0467,
              EV_InitSpd_Kmph: 30,
              Overlap_per: 25,
              Tgt_InitPos_m: 917.910964399093,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400EUR142742",
            name: "p0254020-p090",
            InputParameters: {
              EV_InitPos_m: 786.2689,
              EV_InitSpd_Kmph: 40,
              Overlap_per: 25,
              Tgt_InitPos_m: 974.95309604434362,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400EUR142742",
            name: "p0254030-p090",
            InputParameters: {
              EV_InitPos_m: 786.2689,
              EV_InitSpd_Kmph: 40,
              Overlap_per: 25,
              Tgt_InitPos_m: 961.87361609977324,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.21 sec.",
          },
          {
            uuid: "1400EUR142742",
            name: "p0254040-p090",
            InputParameters: {
              EV_InitPos_m: 786.2689,
              EV_InitSpd_Kmph: 40,
              Overlap_per: 25,
              Tgt_InitPos_m: 948.0067841773747,
              Tgt_InitSpd_Kmph: 40,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.21 sec.",
          },
          {
            uuid: "1400EUR142742",
            name: "p0254050-p090",
            InputParameters: {
              EV_InitPos_m: 786.2689,
              EV_InitSpd_Kmph: 40,
              Overlap_per: 25,
              Tgt_InitPos_m: 933.3525002771479,
              Tgt_InitSpd_Kmph: 50,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.21 sec.",
          },
          {
            uuid: "1400EUR142742",
            name: "p0254060-p090",
            InputParameters: {
              EV_InitPos_m: 786.2689,
              EV_InitSpd_Kmph: 40,
              Overlap_per: 25,
              Tgt_InitPos_m: 917.910964399093,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.21 sec.",
          },
          {
            uuid: "1400EUR142742",
            name: "p0255020-p090",
            InputParameters: {
              EV_InitPos_m: 733.4911,
              EV_InitSpd_Kmph: 50,
              Overlap_per: 25,
              Tgt_InitPos_m: 974.95309604434362,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400EUR142742",
            name: "p0255030-p090",
            InputParameters: {
              EV_InitPos_m: 733.4911,
              EV_InitSpd_Kmph: 50,
              Overlap_per: 25,
              Tgt_InitPos_m: 961.87361609977324,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.21 sec.",
          },
          {
            uuid: "1400EUR142742",
            name: "p0255040-p090",
            InputParameters: {
              EV_InitPos_m: 733.4911,
              EV_InitSpd_Kmph: 50,
              Overlap_per: 25,
              Tgt_InitPos_m: 948.0067841773747,
              Tgt_InitSpd_Kmph: 40,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.21 sec.",
          },
          {
            uuid: "1400EUR142742",
            name: "p0255050-p090",
            InputParameters: {
              EV_InitPos_m: 733.4911,
              EV_InitSpd_Kmph: 50,
              Overlap_per: 25,
              Tgt_InitPos_m: 933.3525002771479,
              Tgt_InitSpd_Kmph: 50,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.21 sec.",
          },
          {
            uuid: "1400EUR142742",
            name: "p0255060-p090",
            InputParameters: {
              EV_InitPos_m: 733.4911,
              EV_InitSpd_Kmph: 50,
              Overlap_per: 25,
              Tgt_InitPos_m: 917.910964399093,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.21 sec.",
          },
          {
            uuid: "1400EUR142742",
            name: "p0256020-p090",
            InputParameters: {
              EV_InitPos_m: 680.7133,
              EV_InitSpd_Kmph: 60,
              Overlap_per: 25,
              Tgt_InitPos_m: 974.95309604434362,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400EUR142742",
            name: "p0256030-p090",
            InputParameters: {
              EV_InitPos_m: 680.7133,
              EV_InitSpd_Kmph: 60,
              Overlap_per: 25,
              Tgt_InitPos_m: 961.87361609977324,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.23 sec.",
          },
          {
            uuid: "1400EUR142742",
            name: "p0256040-p090",
            InputParameters: {
              EV_InitPos_m: 680.7133,
              EV_InitSpd_Kmph: 60,
              Overlap_per: 25,
              Tgt_InitPos_m: 948.0067841773747,
              Tgt_InitSpd_Kmph: 40,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.23 sec.",
          },
          {
            uuid: "1400EUR142742",
            name: "p0256050-p090",
            InputParameters: {
              EV_InitPos_m: 680.7133,
              EV_InitSpd_Kmph: 60,
              Overlap_per: 25,
              Tgt_InitPos_m: 933.3525002771479,
              Tgt_InitSpd_Kmph: 50,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.17 sec.",
          },
          {
            uuid: "1400EUR142742",
            name: "p0256060-p090",
            InputParameters: {
              EV_InitPos_m: 680.7133,
              EV_InitSpd_Kmph: 60,
              Overlap_per: 25,
              Tgt_InitPos_m: 917.910964399093,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.17 sec.",
          },
        ],
      },
      {
        execution_id: "20240610142742",
        summary: {
          uuid: "1400HND142742",
          Scenario: "1400HND",
          Mandatory_Target: {
            Total_Variations_Executed: 56,
            Passed: 17,
            Failed: 39,
            Pass_Percentage: 30.36,
          },
          Development_Target: {
            Total_Variations_Executed: 56,
            Passed: 10,
            Failed: 46,
            Pass_Percentage: 17.86,
          },
        },
        variations: [
          {
            uuid: "1400HND142742",
            name: "p0252070-p090",
            InputParameters: {
              EV_InitPos_m: 891.8244,
              EV_InitSpd_Kmph: 20,
              Overlap_per: 25,
              Tgt_InitPos_m: 901.68207654321,
              Tgt_InitSpd_Kmph: 70,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400HND142742",
            name: "p0252080-p090",
            InputParameters: {
              EV_InitPos_m: 891.8244,
              EV_InitSpd_Kmph: 20,
              Overlap_per: 25,
              Tgt_InitPos_m: 884.66583670949854,
              Tgt_InitSpd_Kmph: 80,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400HND142742",
            name: "p0252090-p090",
            InputParameters: {
              EV_InitPos_m: 891.8244,
              EV_InitSpd_Kmph: 20,
              Overlap_per: 25,
              Tgt_InitPos_m: 866.86224489795916,
              Tgt_InitSpd_Kmph: 90,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400HND142742",
            name: "p0252096-p090",
            InputParameters: {
              EV_InitPos_m: 891.8244,
              EV_InitSpd_Kmph: 20,
              Overlap_per: 25,
              Tgt_InitPos_m: 855.80212086167808,
              Tgt_InitSpd_Kmph: 96,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400HND142742",
            name: "p0253070-p090",
            InputParameters: {
              EV_InitPos_m: 839.0467,
              EV_InitSpd_Kmph: 30,
              Overlap_per: 25,
              Tgt_InitPos_m: 901.68207654321,
              Tgt_InitSpd_Kmph: 70,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.16 sec.",
          },
          {
            uuid: "1400HND142742",
            name: "p0253080-p090",
            InputParameters: {
              EV_InitPos_m: 839.0467,
              EV_InitSpd_Kmph: 30,
              Overlap_per: 25,
              Tgt_InitPos_m: 884.66583670949854,
              Tgt_InitSpd_Kmph: 80,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.16 sec.",
          },
          {
            uuid: "1400HND142742",
            name: "p0253090-p090",
            InputParameters: {
              EV_InitPos_m: 839.0467,
              EV_InitSpd_Kmph: 30,
              Overlap_per: 25,
              Tgt_InitPos_m: 866.86224489795916,
              Tgt_InitSpd_Kmph: 90,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.16 sec.",
          },
          {
            uuid: "1400HND142742",
            name: "p0253096-p090",
            InputParameters: {
              EV_InitPos_m: 839.0467,
              EV_InitSpd_Kmph: 30,
              Overlap_per: 25,
              Tgt_InitPos_m: 855.80212086167808,
              Tgt_InitSpd_Kmph: 96,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400HND142742",
            name: "p0254070-p090",
            InputParameters: {
              EV_InitPos_m: 786.2689,
              EV_InitSpd_Kmph: 40,
              Overlap_per: 25,
              Tgt_InitPos_m: 901.68207654321,
              Tgt_InitSpd_Kmph: 70,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400HND142742",
            name: "p0254080-p090",
            InputParameters: {
              EV_InitPos_m: 786.2689,
              EV_InitSpd_Kmph: 40,
              Overlap_per: 25,
              Tgt_InitPos_m: 884.66583670949854,
              Tgt_InitSpd_Kmph: 80,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.13 sec.",
          },
          {
            uuid: "1400HND142742",
            name: "p0254090-p090",
            InputParameters: {
              EV_InitPos_m: 786.2689,
              EV_InitSpd_Kmph: 40,
              Overlap_per: 25,
              Tgt_InitPos_m: 866.86224489795916,
              Tgt_InitSpd_Kmph: 90,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.13 sec.",
          },
          {
            uuid: "1400HND142742",
            name: "p0254096-p090",
            InputParameters: {
              EV_InitPos_m: 786.2689,
              EV_InitSpd_Kmph: 40,
              Overlap_per: 25,
              Tgt_InitPos_m: 855.80212086167808,
              Tgt_InitSpd_Kmph: 96,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.13 sec.",
          },
          {
            uuid: "1400HND142742",
            name: "p0255070-p090",
            InputParameters: {
              EV_InitPos_m: 733.4911,
              EV_InitSpd_Kmph: 50,
              Overlap_per: 25,
              Tgt_InitPos_m: 901.68207654321,
              Tgt_InitSpd_Kmph: 70,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.13 sec.",
          },
          {
            uuid: "1400HND142742",
            name: "p0255080-p090",
            InputParameters: {
              EV_InitPos_m: 733.4911,
              EV_InitSpd_Kmph: 50,
              Overlap_per: 25,
              Tgt_InitPos_m: 884.66583670949854,
              Tgt_InitSpd_Kmph: 80,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.13 sec.",
          },
          {
            uuid: "1400HND142742",
            name: "p0255090-p090",
            InputParameters: {
              EV_InitPos_m: 733.4911,
              EV_InitSpd_Kmph: 50,
              Overlap_per: 25,
              Tgt_InitPos_m: 866.86224489795916,
              Tgt_InitSpd_Kmph: 90,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.13 sec.",
          },
          {
            uuid: "1400HND142742",
            name: "p0255096-p090",
            InputParameters: {
              EV_InitPos_m: 733.4911,
              EV_InitSpd_Kmph: 50,
              Overlap_per: 25,
              Tgt_InitPos_m: 855.80212086167808,
              Tgt_InitSpd_Kmph: 96,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.13 sec.",
          },
          {
            uuid: "1400HND142742",
            name: "p0256070-p090",
            InputParameters: {
              EV_InitPos_m: 680.7133,
              EV_InitSpd_Kmph: 60,
              Overlap_per: 25,
              Tgt_InitPos_m: 901.68207654321,
              Tgt_InitSpd_Kmph: 70,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.17 sec.",
          },
          {
            uuid: "1400HND142742",
            name: "p0256080-p090",
            InputParameters: {
              EV_InitPos_m: 680.7133,
              EV_InitSpd_Kmph: 60,
              Overlap_per: 25,
              Tgt_InitPos_m: 884.66583670949854,
              Tgt_InitSpd_Kmph: 80,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.17 sec.",
          },
          {
            uuid: "1400HND142742",
            name: "p0256090-p090",
            InputParameters: {
              EV_InitPos_m: 680.7133,
              EV_InitSpd_Kmph: 60,
              Overlap_per: 25,
              Tgt_InitPos_m: 866.86224489795916,
              Tgt_InitSpd_Kmph: 90,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.11 sec.",
          },
          {
            uuid: "1400HND142742",
            name: "p0256096-p090",
            InputParameters: {
              EV_InitPos_m: 680.7133,
              EV_InitSpd_Kmph: 60,
              Overlap_per: 25,
              Tgt_InitPos_m: 855.80212086167808,
              Tgt_InitSpd_Kmph: 96,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.11 sec.",
          },
          {
            uuid: "1400HND142742",
            name: "p0257020-p090",
            InputParameters: {
              EV_InitPos_m: 627.9356,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 25,
              Tgt_InitPos_m: 974.95309604434362,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1400HND142742",
            name: "p0257030-p090",
            InputParameters: {
              EV_InitPos_m: 627.9356,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 25,
              Tgt_InitPos_m: 961.87361609977324,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 23.24 km/h.",
          },
          {
            uuid: "1400HND142742",
            name: "p0257040-p090",
            InputParameters: {
              EV_InitPos_m: 627.9356,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 25,
              Tgt_InitPos_m: 948.0067841773747,
              Tgt_InitSpd_Kmph: 40,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 16.58 km/h.",
          },
          {
            uuid: "1400HND142742",
            name: "p0257050-p090",
            InputParameters: {
              EV_InitPos_m: 627.9356,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 25,
              Tgt_InitPos_m: 933.3525002771479,
              Tgt_InitSpd_Kmph: 50,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 13.24 km/h.",
          },
          {
            uuid: "1400HND142742",
            name: "p0257060-p090",
            InputParameters: {
              EV_InitPos_m: 627.9356,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 25,
              Tgt_InitPos_m: 917.910964399093,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 9.92 km/h.",
          },
          {
            uuid: "1400HND142742",
            name: "p0257070-p090",
            InputParameters: {
              EV_InitPos_m: 627.9356,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 25,
              Tgt_InitPos_m: 901.68207654321,
              Tgt_InitSpd_Kmph: 70,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 9.92 km/h.",
          },
          {
            uuid: "1400HND142742",
            name: "p0257080-p090",
            InputParameters: {
              EV_InitPos_m: 627.9356,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 25,
              Tgt_InitPos_m: 884.66583670949854,
              Tgt_InitSpd_Kmph: 80,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 9.92 km/h.",
          },
          {
            uuid: "1400HND142742",
            name: "p0257090-p090",
            InputParameters: {
              EV_InitPos_m: 627.9356,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 25,
              Tgt_InitPos_m: 866.86224489795916,
              Tgt_InitSpd_Kmph: 90,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 9.92 km/h.",
          },
          {
            uuid: "1400HND142742",
            name: "p0257096-p090",
            InputParameters: {
              EV_InitPos_m: 627.9356,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 25,
              Tgt_InitPos_m: 855.80212086167808,
              Tgt_InitSpd_Kmph: 96,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 9.92 km/h.",
          },
          {
            uuid: "1400HND142742",
            name: "p0258020-p090",
            InputParameters: {
              EV_InitPos_m: 575.1578,
              EV_InitSpd_Kmph: 80,
              Overlap_per: 25,
              Tgt_InitPos_m: 974.95309604434362,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 48.97 km/h.",
          },
          {
            uuid: "1400HND142742",
            name: "p0258030-p090",
            InputParameters: {
              EV_InitPos_m: 575.1578,
              EV_InitSpd_Kmph: 80,
              Overlap_per: 25,
              Tgt_InitPos_m: 961.87361609977324,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 48.97 km/h.",
          },
          {
            uuid: "1400HND142742",
            name: "p0258040-p090",
            InputParameters: {
              EV_InitPos_m: 575.1578,
              EV_InitSpd_Kmph: 80,
              Overlap_per: 25,
              Tgt_InitPos_m: 948.0067841773747,
              Tgt_InitSpd_Kmph: 40,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1400HND142742",
            name: "p0258050-p090",
            InputParameters: {
              EV_InitPos_m: 575.1578,
              EV_InitSpd_Kmph: 80,
              Overlap_per: 25,
              Tgt_InitPos_m: 933.3525002771479,
              Tgt_InitSpd_Kmph: 50,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 16.63 km/h.",
          },
          {
            uuid: "1400HND142742",
            name: "p0258060-p090",
            InputParameters: {
              EV_InitPos_m: 575.1578,
              EV_InitSpd_Kmph: 80,
              Overlap_per: 25,
              Tgt_InitPos_m: 917.910964399093,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 13.35 km/h.",
          },
          {
            uuid: "1400HND142742",
            name: "p0258070-p090",
            InputParameters: {
              EV_InitPos_m: 575.1578,
              EV_InitSpd_Kmph: 80,
              Overlap_per: 25,
              Tgt_InitPos_m: 901.68207654321,
              Tgt_InitSpd_Kmph: 70,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 13.35 km/h.",
          },
          {
            uuid: "1400HND142742",
            name: "p0258080-p090",
            InputParameters: {
              EV_InitPos_m: 575.1578,
              EV_InitSpd_Kmph: 80,
              Overlap_per: 25,
              Tgt_InitPos_m: 884.66583670949854,
              Tgt_InitSpd_Kmph: 80,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 10.06 km/h.",
          },
          {
            uuid: "1400HND142742",
            name: "p0258090-p090",
            InputParameters: {
              EV_InitPos_m: 575.1578,
              EV_InitSpd_Kmph: 80,
              Overlap_per: 25,
              Tgt_InitPos_m: 866.86224489795916,
              Tgt_InitSpd_Kmph: 90,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 10.06 km/h.",
          },
          {
            uuid: "1400HND142742",
            name: "p0258096-p090",
            InputParameters: {
              EV_InitPos_m: 575.1578,
              EV_InitSpd_Kmph: 80,
              Overlap_per: 25,
              Tgt_InitPos_m: 855.80212086167808,
              Tgt_InitSpd_Kmph: 96,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 10.06 km/h.",
          },
          {
            uuid: "1400HND142742",
            name: "p0259020-p090",
            InputParameters: {
              EV_InitPos_m: 522.38,
              EV_InitSpd_Kmph: 90,
              Overlap_per: 25,
              Tgt_InitPos_m: 974.95309604434362,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 52.41 km/h.",
          },
          {
            uuid: "1400HND142742",
            name: "p0259030-p090",
            InputParameters: {
              EV_InitPos_m: 522.38,
              EV_InitSpd_Kmph: 90,
              Overlap_per: 25,
              Tgt_InitPos_m: 961.87361609977324,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1400HND142742",
            name: "p0259040-p090",
            InputParameters: {
              EV_InitPos_m: 522.38,
              EV_InitSpd_Kmph: 90,
              Overlap_per: 25,
              Tgt_InitPos_m: 948.0067841773747,
              Tgt_InitSpd_Kmph: 40,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 26.70 km/h.",
          },
          {
            uuid: "1400HND142742",
            name: "p0259050-p090",
            InputParameters: {
              EV_InitPos_m: 522.38,
              EV_InitSpd_Kmph: 90,
              Overlap_per: 25,
              Tgt_InitPos_m: 933.3525002771479,
              Tgt_InitSpd_Kmph: 50,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 16.99 km/h.",
          },
          {
            uuid: "1400HND142742",
            name: "p0259060-p090",
            InputParameters: {
              EV_InitPos_m: 522.38,
              EV_InitSpd_Kmph: 90,
              Overlap_per: 25,
              Tgt_InitPos_m: 917.910964399093,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 13.72 km/h.",
          },
          {
            uuid: "1400HND142742",
            name: "p0259070-p090",
            InputParameters: {
              EV_InitPos_m: 522.38,
              EV_InitSpd_Kmph: 90,
              Overlap_per: 25,
              Tgt_InitPos_m: 901.68207654321,
              Tgt_InitSpd_Kmph: 70,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 13.72 km/h.",
          },
          {
            uuid: "1400HND142742",
            name: "p0259080-p090",
            InputParameters: {
              EV_InitPos_m: 522.38,
              EV_InitSpd_Kmph: 90,
              Overlap_per: 25,
              Tgt_InitPos_m: 884.66583670949854,
              Tgt_InitSpd_Kmph: 80,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 10.46 km/h.",
          },
          {
            uuid: "1400HND142742",
            name: "p0259090-p090",
            InputParameters: {
              EV_InitPos_m: 522.38,
              EV_InitSpd_Kmph: 90,
              Overlap_per: 25,
              Tgt_InitPos_m: 866.86224489795916,
              Tgt_InitSpd_Kmph: 90,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 10.46 km/h.",
          },
          {
            uuid: "1400HND142742",
            name: "p0259096-p090",
            InputParameters: {
              EV_InitPos_m: 522.38,
              EV_InitSpd_Kmph: 90,
              Overlap_per: 25,
              Tgt_InitPos_m: 855.80212086167808,
              Tgt_InitSpd_Kmph: 96,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 10.46 km/h.",
          },
          {
            uuid: "1400HND142742",
            name: "p0259620-p090",
            InputParameters: {
              EV_InitPos_m: 490.7133,
              EV_InitSpd_Kmph: 96,
              Overlap_per: 25,
              Tgt_InitPos_m: 974.95309604434362,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 50.42 km/h.",
          },
          {
            uuid: "1400HND142742",
            name: "p0259630-p090",
            InputParameters: {
              EV_InitPos_m: 490.7133,
              EV_InitSpd_Kmph: 96,
              Overlap_per: 25,
              Tgt_InitPos_m: 961.87361609977324,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 50.42 km/h.",
          },
          {
            uuid: "1400HND142742",
            name: "p0259640-p090",
            InputParameters: {
              EV_InitPos_m: 490.7133,
              EV_InitSpd_Kmph: 96,
              Overlap_per: 25,
              Tgt_InitPos_m: 948.0067841773747,
              Tgt_InitSpd_Kmph: 40,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1400HND142742",
            name: "p0259650-p090",
            InputParameters: {
              EV_InitPos_m: 490.7133,
              EV_InitSpd_Kmph: 96,
              Overlap_per: 25,
              Tgt_InitPos_m: 933.3525002771479,
              Tgt_InitSpd_Kmph: 50,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 20.31 km/h.",
          },
          {
            uuid: "1400HND142742",
            name: "p0259660-p090",
            InputParameters: {
              EV_InitPos_m: 490.7133,
              EV_InitSpd_Kmph: 96,
              Overlap_per: 25,
              Tgt_InitPos_m: 917.910964399093,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 17.09 km/h.",
          },
          {
            uuid: "1400HND142742",
            name: "p0259670-p090",
            InputParameters: {
              EV_InitPos_m: 490.7133,
              EV_InitSpd_Kmph: 96,
              Overlap_per: 25,
              Tgt_InitPos_m: 901.68207654321,
              Tgt_InitSpd_Kmph: 70,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 13.82 km/h.",
          },
          {
            uuid: "1400HND142742",
            name: "p0259680-p090",
            InputParameters: {
              EV_InitPos_m: 490.7133,
              EV_InitSpd_Kmph: 96,
              Overlap_per: 25,
              Tgt_InitPos_m: 884.66583670949854,
              Tgt_InitSpd_Kmph: 80,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 10.57 km/h.",
          },
          {
            uuid: "1400HND142742",
            name: "p0259690-p090",
            InputParameters: {
              EV_InitPos_m: 490.7133,
              EV_InitSpd_Kmph: 96,
              Overlap_per: 25,
              Tgt_InitPos_m: 866.86224489795916,
              Tgt_InitSpd_Kmph: 90,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 10.57 km/h.",
          },
          {
            uuid: "1400HND142742",
            name: "p0259696-p090",
            InputParameters: {
              EV_InitPos_m: 490.7133,
              EV_InitSpd_Kmph: 96,
              Overlap_per: 25,
              Tgt_InitPos_m: 855.80212086167808,
              Tgt_InitSpd_Kmph: 96,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 10.57 km/h.",
          },
        ],
      },
      {
        execution_id: "20240610142742",
        summary: {
          uuid: "1400HND_LC142742",
          Scenario: "1400HND_LC",
          Mandatory_Target: {
            Total_Variations_Executed: 137,
            Passed: 93,
            Failed: 44,
            Pass_Percentage: 67.88,
          },
          Development_Target: {
            Total_Variations_Executed: 137,
            Passed: 43,
            Failed: 94,
            Pass_Percentage: 31.39,
          },
        },
        variations: [
          {
            uuid: "1400HND_LC142742",
            name: "p0002070-n090",
            InputParameters: {
              EV_InitPos_m: 895.3244,
              EV_InitSpd_Kmph: 20,
              Overlap_per: 0,
              Tgt_InitPos_m: 896.18207654321,
              Tgt_InitSpd_Kmph: 70,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0002080-n090",
            InputParameters: {
              EV_InitPos_m: 895.3244,
              EV_InitSpd_Kmph: 20,
              Overlap_per: 0,
              Tgt_InitPos_m: 879.16583670949854,
              Tgt_InitSpd_Kmph: 80,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0002090-n090",
            InputParameters: {
              EV_InitPos_m: 895.3244,
              EV_InitSpd_Kmph: 20,
              Overlap_per: 0,
              Tgt_InitPos_m: 861.36224489795916,
              Tgt_InitSpd_Kmph: 90,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0002096-n090",
            InputParameters: {
              EV_InitPos_m: 895.3244,
              EV_InitSpd_Kmph: 20,
              Overlap_per: 0,
              Tgt_InitPos_m: 850.30212086167808,
              Tgt_InitSpd_Kmph: 96,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0003070-n090",
            InputParameters: {
              EV_InitPos_m: 842.5467,
              EV_InitSpd_Kmph: 30,
              Overlap_per: 0,
              Tgt_InitPos_m: 896.18207654321,
              Tgt_InitSpd_Kmph: 70,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0003080-n090",
            InputParameters: {
              EV_InitPos_m: 842.5467,
              EV_InitSpd_Kmph: 30,
              Overlap_per: 0,
              Tgt_InitPos_m: 879.16583670949854,
              Tgt_InitSpd_Kmph: 80,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: 'Not tested for KPI "No requirement".',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0003090-n090",
            InputParameters: {
              EV_InitPos_m: 842.5467,
              EV_InitSpd_Kmph: 30,
              Overlap_per: 0,
              Tgt_InitPos_m: 861.36224489795916,
              Tgt_InitSpd_Kmph: 90,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Collision occurred at 19.16 sec.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0003096-n090",
            InputParameters: {
              EV_InitPos_m: 842.5467,
              EV_InitSpd_Kmph: 30,
              Overlap_per: 0,
              Tgt_InitPos_m: 850.30212086167808,
              Tgt_InitSpd_Kmph: 96,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Collision occurred at 19.16 sec.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0004070-n090",
            InputParameters: {
              EV_InitPos_m: 789.7689,
              EV_InitSpd_Kmph: 40,
              Overlap_per: 0,
              Tgt_InitPos_m: 896.18207654321,
              Tgt_InitSpd_Kmph: 70,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Collision occurred at 19.21 sec.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0004080-n090",
            InputParameters: {
              EV_InitPos_m: 789.7689,
              EV_InitSpd_Kmph: 40,
              Overlap_per: 0,
              Tgt_InitPos_m: 879.16583670949854,
              Tgt_InitSpd_Kmph: 80,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Collision occurred at 19.21 sec.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0004090-n090",
            InputParameters: {
              EV_InitPos_m: 789.7689,
              EV_InitSpd_Kmph: 40,
              Overlap_per: 0,
              Tgt_InitPos_m: 861.36224489795916,
              Tgt_InitSpd_Kmph: 90,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Collision occurred at 19.21 sec.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0004096-n090",
            InputParameters: {
              EV_InitPos_m: 789.7689,
              EV_InitSpd_Kmph: 40,
              Overlap_per: 0,
              Tgt_InitPos_m: 850.30212086167808,
              Tgt_InitSpd_Kmph: 96,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Collision occurred at 19.21 sec.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0005070-n090",
            InputParameters: {
              EV_InitPos_m: 736.9911,
              EV_InitSpd_Kmph: 50,
              Overlap_per: 0,
              Tgt_InitPos_m: 896.18207654321,
              Tgt_InitSpd_Kmph: 70,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Collision occurred at 19.21 sec.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0005080-n090",
            InputParameters: {
              EV_InitPos_m: 736.9911,
              EV_InitSpd_Kmph: 50,
              Overlap_per: 0,
              Tgt_InitPos_m: 879.16583670949854,
              Tgt_InitSpd_Kmph: 80,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Collision occurred at 19.21 sec.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0005090-n090",
            InputParameters: {
              EV_InitPos_m: 736.9911,
              EV_InitSpd_Kmph: 50,
              Overlap_per: 0,
              Tgt_InitPos_m: 861.36224489795916,
              Tgt_InitSpd_Kmph: 90,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Collision occurred at 19.21 sec.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0005096-n090",
            InputParameters: {
              EV_InitPos_m: 736.9911,
              EV_InitSpd_Kmph: 50,
              Overlap_per: 0,
              Tgt_InitPos_m: 850.30212086167808,
              Tgt_InitSpd_Kmph: 96,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Collision occurred at 19.13 sec.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0006070-n090",
            InputParameters: {
              EV_InitPos_m: 684.2133,
              EV_InitSpd_Kmph: 60,
              Overlap_per: 0,
              Tgt_InitPos_m: 896.18207654321,
              Tgt_InitSpd_Kmph: 70,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Collision occurred at 19.17 sec.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0006080-n090",
            InputParameters: {
              EV_InitPos_m: 684.2133,
              EV_InitSpd_Kmph: 60,
              Overlap_per: 0,
              Tgt_InitPos_m: 879.16583670949854,
              Tgt_InitSpd_Kmph: 80,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Collision occurred at 19.17 sec.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0006090-n090",
            InputParameters: {
              EV_InitPos_m: 684.2133,
              EV_InitSpd_Kmph: 60,
              Overlap_per: 0,
              Tgt_InitPos_m: 861.36224489795916,
              Tgt_InitSpd_Kmph: 90,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Collision occurred at 19.17 sec.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0006096-n090",
            InputParameters: {
              EV_InitPos_m: 684.2133,
              EV_InitSpd_Kmph: 60,
              Overlap_per: 0,
              Tgt_InitPos_m: 850.30212086167808,
              Tgt_InitSpd_Kmph: 96,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Collision occurred at 19.17 sec.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0007020-n090",
            InputParameters: {
              EV_InitPos_m: 631.4356,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 0,
              Tgt_InitPos_m: 969.45309604434362,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Not tested for KPI "No requirement".\n\nSpeed dropped by 57.67 km/h.',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0007030-n090",
            InputParameters: {
              EV_InitPos_m: 631.4356,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 0,
              Tgt_InitPos_m: 956.37361609977324,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks:
              'No collision occurred.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0007040-n090",
            InputParameters: {
              EV_InitPos_m: 631.4356,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 0,
              Tgt_InitPos_m: 942.5067841773747,
              Tgt_InitSpd_Kmph: 40,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Not tested for KPI "No requirement".\n\nSpeed dropped by 23.24 km/h.',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0007050-n090",
            InputParameters: {
              EV_InitPos_m: 631.4356,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 0,
              Tgt_InitPos_m: 927.8525002771479,
              Tgt_InitSpd_Kmph: 50,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Not tested for KPI "No requirement".\n\nSpeed dropped by 16.58 km/h.',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0007060-n090",
            InputParameters: {
              EV_InitPos_m: 631.4356,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 0,
              Tgt_InitPos_m: 912.410964399093,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Not tested for KPI "No requirement".\n\nSpeed dropped by 16.58 km/h.',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0007070-n090",
            InputParameters: {
              EV_InitPos_m: 631.4356,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 0,
              Tgt_InitPos_m: 896.18207654321,
              Tgt_InitSpd_Kmph: 70,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Not tested for KPI "No requirement".\n\nSpeed dropped by 13.24 km/h.',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0007080-n090",
            InputParameters: {
              EV_InitPos_m: 631.4356,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 0,
              Tgt_InitPos_m: 879.16583670949854,
              Tgt_InitSpd_Kmph: 80,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Not tested for KPI "No requirement".\n\nSpeed dropped by 13.24 km/h.',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0007090-n090",
            InputParameters: {
              EV_InitPos_m: 631.4356,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 0,
              Tgt_InitPos_m: 861.36224489795916,
              Tgt_InitSpd_Kmph: 90,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Not tested for KPI "No requirement".\n\nSpeed dropped by 9.92 km/h.',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0007096-n090",
            InputParameters: {
              EV_InitPos_m: 631.4356,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 0,
              Tgt_InitPos_m: 850.30212086167808,
              Tgt_InitSpd_Kmph: 96,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Not tested for KPI "No requirement".\n\nSpeed dropped by 9.92 km/h.',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0008020-n090",
            InputParameters: {
              EV_InitPos_m: 578.6578,
              EV_InitSpd_Kmph: 80,
              Overlap_per: 0,
              Tgt_InitPos_m: 969.45309604434362,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Not tested for KPI "No requirement".\n\nSpeed dropped by 48.97 km/h.',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0008030-n090",
            InputParameters: {
              EV_InitPos_m: 578.6578,
              EV_InitSpd_Kmph: 80,
              Overlap_per: 0,
              Tgt_InitPos_m: 956.37361609977324,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Not tested for KPI "No requirement".\n\nSpeed dropped by 48.97 km/h.',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0008040-n090",
            InputParameters: {
              EV_InitPos_m: 578.6578,
              EV_InitSpd_Kmph: 80,
              Overlap_per: 0,
              Tgt_InitPos_m: 942.5067841773747,
              Tgt_InitSpd_Kmph: 40,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Not tested for KPI "No requirement".\n\nSpeed dropped by 48.97 km/h.',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0008050-n090",
            InputParameters: {
              EV_InitPos_m: 578.6578,
              EV_InitSpd_Kmph: 80,
              Overlap_per: 0,
              Tgt_InitPos_m: 927.8525002771479,
              Tgt_InitSpd_Kmph: 50,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks:
              'No collision occurred.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0008060-n090",
            InputParameters: {
              EV_InitPos_m: 578.6578,
              EV_InitSpd_Kmph: 80,
              Overlap_per: 0,
              Tgt_InitPos_m: 912.410964399093,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Not tested for KPI "No requirement".\n\nSpeed dropped by 23.14 km/h.',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0008070-n090",
            InputParameters: {
              EV_InitPos_m: 578.6578,
              EV_InitSpd_Kmph: 80,
              Overlap_per: 0,
              Tgt_InitPos_m: 896.18207654321,
              Tgt_InitSpd_Kmph: 70,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Not tested for KPI "No requirement".\n\nSpeed dropped by 16.63 km/h.',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0008080-n090",
            InputParameters: {
              EV_InitPos_m: 578.6578,
              EV_InitSpd_Kmph: 80,
              Overlap_per: 0,
              Tgt_InitPos_m: 879.16583670949854,
              Tgt_InitSpd_Kmph: 80,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Not tested for KPI "No requirement".\n\nSpeed dropped by 13.35 km/h.',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0008090-n090",
            InputParameters: {
              EV_InitPos_m: 578.6578,
              EV_InitSpd_Kmph: 80,
              Overlap_per: 0,
              Tgt_InitPos_m: 861.36224489795916,
              Tgt_InitSpd_Kmph: 90,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Not tested for KPI "No requirement".\n\nSpeed dropped by 13.35 km/h.',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0008096-n090",
            InputParameters: {
              EV_InitPos_m: 578.6578,
              EV_InitSpd_Kmph: 80,
              Overlap_per: 0,
              Tgt_InitPos_m: 850.30212086167808,
              Tgt_InitSpd_Kmph: 96,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Not tested for KPI "No requirement".\n\nSpeed dropped by 13.35 km/h.',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0009020-n090",
            InputParameters: {
              EV_InitPos_m: 525.88,
              EV_InitSpd_Kmph: 90,
              Overlap_per: 0,
              Tgt_InitPos_m: 969.45309604434362,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Not tested for KPI "No requirement".\n\nSpeed dropped by 52.41 km/h.',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0009030-n090",
            InputParameters: {
              EV_InitPos_m: 525.88,
              EV_InitSpd_Kmph: 90,
              Overlap_per: 0,
              Tgt_InitPos_m: 956.37361609977324,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Not tested for KPI "No requirement".\n\nSpeed dropped by 52.41 km/h.',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0009040-n090",
            InputParameters: {
              EV_InitPos_m: 525.88,
              EV_InitSpd_Kmph: 90,
              Overlap_per: 0,
              Tgt_InitPos_m: 942.5067841773747,
              Tgt_InitSpd_Kmph: 40,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Not tested for KPI "No requirement".\n\nSpeed dropped by 52.41 km/h.',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0009050-n090",
            InputParameters: {
              EV_InitPos_m: 525.88,
              EV_InitSpd_Kmph: 90,
              Overlap_per: 0,
              Tgt_InitPos_m: 927.8525002771479,
              Tgt_InitSpd_Kmph: 50,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks:
              'No collision occurred.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0009060-n090",
            InputParameters: {
              EV_InitPos_m: 525.88,
              EV_InitSpd_Kmph: 90,
              Overlap_per: 0,
              Tgt_InitPos_m: 912.410964399093,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Not tested for KPI "No requirement".\n\nSpeed dropped by 20.25 km/h.',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0009070-n090",
            InputParameters: {
              EV_InitPos_m: 525.88,
              EV_InitSpd_Kmph: 90,
              Overlap_per: 0,
              Tgt_InitPos_m: 896.18207654321,
              Tgt_InitSpd_Kmph: 70,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Not tested for KPI "No requirement".\n\nSpeed dropped by 16.99 km/h.',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0009080-n090",
            InputParameters: {
              EV_InitPos_m: 525.88,
              EV_InitSpd_Kmph: 90,
              Overlap_per: 0,
              Tgt_InitPos_m: 879.16583670949854,
              Tgt_InitSpd_Kmph: 80,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Not tested for KPI "No requirement".\n\nSpeed dropped by 13.72 km/h.',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0009090-n090",
            InputParameters: {
              EV_InitPos_m: 525.88,
              EV_InitSpd_Kmph: 90,
              Overlap_per: 0,
              Tgt_InitPos_m: 861.36224489795916,
              Tgt_InitSpd_Kmph: 90,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Not tested for KPI "No requirement".\n\nSpeed dropped by 13.72 km/h.',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0009096-n090",
            InputParameters: {
              EV_InitPos_m: 525.88,
              EV_InitSpd_Kmph: 90,
              Overlap_per: 0,
              Tgt_InitPos_m: 850.30212086167808,
              Tgt_InitSpd_Kmph: 96,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Not tested for KPI "No requirement".\n\nSpeed dropped by 13.72 km/h.',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0009620-n090",
            InputParameters: {
              EV_InitPos_m: 494.2133,
              EV_InitSpd_Kmph: 96,
              Overlap_per: 0,
              Tgt_InitPos_m: 969.45309604434362,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Not tested for KPI "No requirement".\n\nSpeed dropped by 50.42 km/h.',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0009630-n090",
            InputParameters: {
              EV_InitPos_m: 494.2133,
              EV_InitSpd_Kmph: 96,
              Overlap_per: 0,
              Tgt_InitPos_m: 956.37361609977324,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Not tested for KPI "No requirement".\n\nSpeed dropped by 50.42 km/h.',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0009640-n090",
            InputParameters: {
              EV_InitPos_m: 494.2133,
              EV_InitSpd_Kmph: 96,
              Overlap_per: 0,
              Tgt_InitPos_m: 942.5067841773747,
              Tgt_InitSpd_Kmph: 40,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Not tested for KPI "No requirement".\n\nSpeed dropped by 50.42 km/h.',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0009650-n090",
            InputParameters: {
              EV_InitPos_m: 494.2133,
              EV_InitSpd_Kmph: 96,
              Overlap_per: 0,
              Tgt_InitPos_m: 927.8525002771479,
              Tgt_InitSpd_Kmph: 50,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Not tested for KPI "No requirement".\n\nSpeed dropped by 50.42 km/h.',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0009660-n090",
            InputParameters: {
              EV_InitPos_m: 494.2133,
              EV_InitSpd_Kmph: 96,
              Overlap_per: 0,
              Tgt_InitPos_m: 912.410964399093,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks:
              'No collision occurred.\n\nNot tested for KPI "No requirement".',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0009670-n090",
            InputParameters: {
              EV_InitPos_m: 494.2133,
              EV_InitSpd_Kmph: 96,
              Overlap_per: 0,
              Tgt_InitPos_m: 896.18207654321,
              Tgt_InitSpd_Kmph: 70,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Not tested for KPI "No requirement".\n\nSpeed dropped by 20.31 km/h.',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0009680-n090",
            InputParameters: {
              EV_InitPos_m: 494.2133,
              EV_InitSpd_Kmph: 96,
              Overlap_per: 0,
              Tgt_InitPos_m: 879.16583670949854,
              Tgt_InitSpd_Kmph: 80,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Not tested for KPI "No requirement".\n\nSpeed dropped by 17.09 km/h.',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0009690-n090",
            InputParameters: {
              EV_InitPos_m: 494.2133,
              EV_InitSpd_Kmph: 96,
              Overlap_per: 0,
              Tgt_InitPos_m: 861.36224489795916,
              Tgt_InitSpd_Kmph: 90,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Not tested for KPI "No requirement".\n\nSpeed dropped by 13.82 km/h.',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0009696-n090",
            InputParameters: {
              EV_InitPos_m: 494.2133,
              EV_InitSpd_Kmph: 96,
              Overlap_per: 0,
              Tgt_InitPos_m: 850.30212086167808,
              Tgt_InitSpd_Kmph: 96,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks:
              'Not tested for KPI "No requirement".\n\nSpeed dropped by 13.82 km/h.',
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0502020-n090",
            InputParameters: {
              EV_InitPos_m: 895.3244,
              EV_InitSpd_Kmph: 20,
              Overlap_per: 50,
              Tgt_InitPos_m: 972.45309604434362,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0502030-n090",
            InputParameters: {
              EV_InitPos_m: 895.3244,
              EV_InitSpd_Kmph: 20,
              Overlap_per: 50,
              Tgt_InitPos_m: 959.37361609977324,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0502040-n090",
            InputParameters: {
              EV_InitPos_m: 895.3244,
              EV_InitSpd_Kmph: 20,
              Overlap_per: 50,
              Tgt_InitPos_m: 945.5067841773747,
              Tgt_InitSpd_Kmph: 40,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0502050-n090",
            InputParameters: {
              EV_InitPos_m: 895.3244,
              EV_InitSpd_Kmph: 20,
              Overlap_per: 50,
              Tgt_InitPos_m: 930.8525002771479,
              Tgt_InitSpd_Kmph: 50,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0502060-n090",
            InputParameters: {
              EV_InitPos_m: 895.3244,
              EV_InitSpd_Kmph: 20,
              Overlap_per: 50,
              Tgt_InitPos_m: 915.410964399093,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0502070-n090",
            InputParameters: {
              EV_InitPos_m: 895.3244,
              EV_InitSpd_Kmph: 20,
              Overlap_per: 50,
              Tgt_InitPos_m: 899.18207654321,
              Tgt_InitSpd_Kmph: 70,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0502080-n090",
            InputParameters: {
              EV_InitPos_m: 895.3244,
              EV_InitSpd_Kmph: 20,
              Overlap_per: 50,
              Tgt_InitPos_m: 882.16583670949854,
              Tgt_InitSpd_Kmph: 80,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0502090-n090",
            InputParameters: {
              EV_InitPos_m: 895.3244,
              EV_InitSpd_Kmph: 20,
              Overlap_per: 50,
              Tgt_InitPos_m: 864.36224489795916,
              Tgt_InitSpd_Kmph: 90,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0502096-n090",
            InputParameters: {
              EV_InitPos_m: 895.3244,
              EV_InitSpd_Kmph: 20,
              Overlap_per: 50,
              Tgt_InitPos_m: 853.30212086167808,
              Tgt_InitSpd_Kmph: 96,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0503020-n090",
            InputParameters: {
              EV_InitPos_m: 842.5467,
              EV_InitSpd_Kmph: 30,
              Overlap_per: 50,
              Tgt_InitPos_m: 972.45309604434362,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0503030-n090",
            InputParameters: {
              EV_InitPos_m: 842.5467,
              EV_InitSpd_Kmph: 30,
              Overlap_per: 50,
              Tgt_InitPos_m: 959.37361609977324,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0503040-n090",
            InputParameters: {
              EV_InitPos_m: 842.5467,
              EV_InitSpd_Kmph: 30,
              Overlap_per: 50,
              Tgt_InitPos_m: 945.5067841773747,
              Tgt_InitSpd_Kmph: 40,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0503050-n090",
            InputParameters: {
              EV_InitPos_m: 842.5467,
              EV_InitSpd_Kmph: 30,
              Overlap_per: 50,
              Tgt_InitPos_m: 930.8525002771479,
              Tgt_InitSpd_Kmph: 50,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0503060-n090",
            InputParameters: {
              EV_InitPos_m: 842.5467,
              EV_InitSpd_Kmph: 30,
              Overlap_per: 50,
              Tgt_InitPos_m: 915.410964399093,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.16 sec.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0503070-n090",
            InputParameters: {
              EV_InitPos_m: 842.5467,
              EV_InitSpd_Kmph: 30,
              Overlap_per: 50,
              Tgt_InitPos_m: 899.18207654321,
              Tgt_InitSpd_Kmph: 70,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.16 sec.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0503080-n090",
            InputParameters: {
              EV_InitPos_m: 842.5467,
              EV_InitSpd_Kmph: 30,
              Overlap_per: 50,
              Tgt_InitPos_m: 882.16583670949854,
              Tgt_InitSpd_Kmph: 80,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0503090-n090",
            InputParameters: {
              EV_InitPos_m: 842.5467,
              EV_InitSpd_Kmph: 30,
              Overlap_per: 50,
              Tgt_InitPos_m: 864.36224489795916,
              Tgt_InitSpd_Kmph: 90,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0503096-n090",
            InputParameters: {
              EV_InitPos_m: 842.5467,
              EV_InitSpd_Kmph: 30,
              Overlap_per: 50,
              Tgt_InitPos_m: 853.30212086167808,
              Tgt_InitSpd_Kmph: 96,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0504020-n090",
            InputParameters: {
              EV_InitPos_m: 789.7689,
              EV_InitSpd_Kmph: 40,
              Overlap_per: 50,
              Tgt_InitPos_m: 972.45309604434362,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0504030-n090",
            InputParameters: {
              EV_InitPos_m: 789.7689,
              EV_InitSpd_Kmph: 40,
              Overlap_per: 50,
              Tgt_InitPos_m: 959.37361609977324,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.21 sec.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0504040-n090",
            InputParameters: {
              EV_InitPos_m: 789.7689,
              EV_InitSpd_Kmph: 40,
              Overlap_per: 50,
              Tgt_InitPos_m: 945.5067841773747,
              Tgt_InitSpd_Kmph: 40,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.21 sec.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0504050-n090",
            InputParameters: {
              EV_InitPos_m: 789.7689,
              EV_InitSpd_Kmph: 40,
              Overlap_per: 50,
              Tgt_InitPos_m: 930.8525002771479,
              Tgt_InitSpd_Kmph: 50,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.21 sec.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0504060-n090",
            InputParameters: {
              EV_InitPos_m: 789.7689,
              EV_InitSpd_Kmph: 40,
              Overlap_per: 50,
              Tgt_InitPos_m: 915.410964399093,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0504070-n090",
            InputParameters: {
              EV_InitPos_m: 789.7689,
              EV_InitSpd_Kmph: 40,
              Overlap_per: 50,
              Tgt_InitPos_m: 899.18207654321,
              Tgt_InitSpd_Kmph: 70,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.13 sec.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0504080-n090",
            InputParameters: {
              EV_InitPos_m: 789.7689,
              EV_InitSpd_Kmph: 40,
              Overlap_per: 50,
              Tgt_InitPos_m: 882.16583670949854,
              Tgt_InitSpd_Kmph: 80,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.13 sec.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0504090-n090",
            InputParameters: {
              EV_InitPos_m: 789.7689,
              EV_InitSpd_Kmph: 40,
              Overlap_per: 50,
              Tgt_InitPos_m: 864.36224489795916,
              Tgt_InitSpd_Kmph: 90,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0504096-n090",
            InputParameters: {
              EV_InitPos_m: 789.7689,
              EV_InitSpd_Kmph: 40,
              Overlap_per: 50,
              Tgt_InitPos_m: 853.30212086167808,
              Tgt_InitSpd_Kmph: 96,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0505020-n090",
            InputParameters: {
              EV_InitPos_m: 736.9911,
              EV_InitSpd_Kmph: 50,
              Overlap_per: 50,
              Tgt_InitPos_m: 972.45309604434362,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0505030-n090",
            InputParameters: {
              EV_InitPos_m: 736.9911,
              EV_InitSpd_Kmph: 50,
              Overlap_per: 50,
              Tgt_InitPos_m: 959.37361609977324,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.21 sec.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0505040-n090",
            InputParameters: {
              EV_InitPos_m: 736.9911,
              EV_InitSpd_Kmph: 50,
              Overlap_per: 50,
              Tgt_InitPos_m: 945.5067841773747,
              Tgt_InitSpd_Kmph: 40,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.21 sec.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0505050-n090",
            InputParameters: {
              EV_InitPos_m: 736.9911,
              EV_InitSpd_Kmph: 50,
              Overlap_per: 50,
              Tgt_InitPos_m: 930.8525002771479,
              Tgt_InitSpd_Kmph: 50,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.21 sec.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0505060-n090",
            InputParameters: {
              EV_InitPos_m: 736.9911,
              EV_InitSpd_Kmph: 50,
              Overlap_per: 50,
              Tgt_InitPos_m: 915.410964399093,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.13 sec.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0505070-n090",
            InputParameters: {
              EV_InitPos_m: 736.9911,
              EV_InitSpd_Kmph: 50,
              Overlap_per: 50,
              Tgt_InitPos_m: 899.18207654321,
              Tgt_InitSpd_Kmph: 70,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.13 sec.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0505080-n090",
            InputParameters: {
              EV_InitPos_m: 736.9911,
              EV_InitSpd_Kmph: 50,
              Overlap_per: 50,
              Tgt_InitPos_m: 882.16583670949854,
              Tgt_InitSpd_Kmph: 80,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.13 sec.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0505090-n090",
            InputParameters: {
              EV_InitPos_m: 736.9911,
              EV_InitSpd_Kmph: 50,
              Overlap_per: 50,
              Tgt_InitPos_m: 864.36224489795916,
              Tgt_InitSpd_Kmph: 90,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0505096-n090",
            InputParameters: {
              EV_InitPos_m: 736.9911,
              EV_InitSpd_Kmph: 50,
              Overlap_per: 50,
              Tgt_InitPos_m: 853.30212086167808,
              Tgt_InitSpd_Kmph: 96,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0506020-n090",
            InputParameters: {
              EV_InitPos_m: 684.2133,
              EV_InitSpd_Kmph: 60,
              Overlap_per: 50,
              Tgt_InitPos_m: 972.45309604434362,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0506030-n090",
            InputParameters: {
              EV_InitPos_m: 684.2133,
              EV_InitSpd_Kmph: 60,
              Overlap_per: 50,
              Tgt_InitPos_m: 959.37361609977324,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.23 sec.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0506040-n090",
            InputParameters: {
              EV_InitPos_m: 684.2133,
              EV_InitSpd_Kmph: 60,
              Overlap_per: 50,
              Tgt_InitPos_m: 945.5067841773747,
              Tgt_InitSpd_Kmph: 40,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.17 sec.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0506050-n090",
            InputParameters: {
              EV_InitPos_m: 684.2133,
              EV_InitSpd_Kmph: 60,
              Overlap_per: 50,
              Tgt_InitPos_m: 930.8525002771479,
              Tgt_InitSpd_Kmph: 50,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.17 sec.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0506060-n090",
            InputParameters: {
              EV_InitPos_m: 684.2133,
              EV_InitSpd_Kmph: 60,
              Overlap_per: 50,
              Tgt_InitPos_m: 915.410964399093,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.17 sec.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0506070-n090",
            InputParameters: {
              EV_InitPos_m: 684.2133,
              EV_InitSpd_Kmph: 60,
              Overlap_per: 50,
              Tgt_InitPos_m: 899.18207654321,
              Tgt_InitSpd_Kmph: 70,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.11 sec.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0506080-n090",
            InputParameters: {
              EV_InitPos_m: 684.2133,
              EV_InitSpd_Kmph: 60,
              Overlap_per: 50,
              Tgt_InitPos_m: 882.16583670949854,
              Tgt_InitSpd_Kmph: 80,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.11 sec.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0506090-n090",
            InputParameters: {
              EV_InitPos_m: 684.2133,
              EV_InitSpd_Kmph: 60,
              Overlap_per: 50,
              Tgt_InitPos_m: 864.36224489795916,
              Tgt_InitSpd_Kmph: 90,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.11 sec.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0506096-n090",
            InputParameters: {
              EV_InitPos_m: 684.2133,
              EV_InitSpd_Kmph: 60,
              Overlap_per: 50,
              Tgt_InitPos_m: 853.30212086167808,
              Tgt_InitSpd_Kmph: 96,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.11 sec.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0507020-n090",
            InputParameters: {
              EV_InitPos_m: 631.4356,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 50,
              Tgt_InitPos_m: 972.45309604434362,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0507030-n090",
            InputParameters: {
              EV_InitPos_m: 631.4356,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 50,
              Tgt_InitPos_m: 959.37361609977324,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 16.58 km/h.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0507040-n090",
            InputParameters: {
              EV_InitPos_m: 631.4356,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 50,
              Tgt_InitPos_m: 945.5067841773747,
              Tgt_InitSpd_Kmph: 40,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 13.24 km/h.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0507050-n090",
            InputParameters: {
              EV_InitPos_m: 631.4356,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 50,
              Tgt_InitPos_m: 930.8525002771479,
              Tgt_InitSpd_Kmph: 50,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 9.92 km/h.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0507060-n090",
            InputParameters: {
              EV_InitPos_m: 631.4356,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 50,
              Tgt_InitPos_m: 915.410964399093,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 9.92 km/h.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0507070-n090",
            InputParameters: {
              EV_InitPos_m: 631.4356,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 50,
              Tgt_InitPos_m: 899.18207654321,
              Tgt_InitSpd_Kmph: 70,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 9.92 km/h.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0507080-n090",
            InputParameters: {
              EV_InitPos_m: 631.4356,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 50,
              Tgt_InitPos_m: 882.16583670949854,
              Tgt_InitSpd_Kmph: 80,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0507090-n090",
            InputParameters: {
              EV_InitPos_m: 631.4356,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 50,
              Tgt_InitPos_m: 864.36224489795916,
              Tgt_InitSpd_Kmph: 90,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 6.59 km/h.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0507096-n090",
            InputParameters: {
              EV_InitPos_m: 631.4356,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 50,
              Tgt_InitPos_m: 853.30212086167808,
              Tgt_InitSpd_Kmph: 96,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 6.59 km/h.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0508020-n090",
            InputParameters: {
              EV_InitPos_m: 578.6578,
              EV_InitSpd_Kmph: 80,
              Overlap_per: 50,
              Tgt_InitPos_m: 972.45309604434362,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 48.97 km/h.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0508030-n090",
            InputParameters: {
              EV_InitPos_m: 578.6578,
              EV_InitSpd_Kmph: 80,
              Overlap_per: 50,
              Tgt_InitPos_m: 959.37361609977324,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0508040-n090",
            InputParameters: {
              EV_InitPos_m: 578.6578,
              EV_InitSpd_Kmph: 80,
              Overlap_per: 50,
              Tgt_InitPos_m: 945.5067841773747,
              Tgt_InitSpd_Kmph: 40,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 16.63 km/h.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0508050-n090",
            InputParameters: {
              EV_InitPos_m: 578.6578,
              EV_InitSpd_Kmph: 80,
              Overlap_per: 50,
              Tgt_InitPos_m: 930.8525002771479,
              Tgt_InitSpd_Kmph: 50,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 13.35 km/h.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0508060-n090",
            InputParameters: {
              EV_InitPos_m: 578.6578,
              EV_InitSpd_Kmph: 80,
              Overlap_per: 50,
              Tgt_InitPos_m: 915.410964399093,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 10.06 km/h.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0508070-n090",
            InputParameters: {
              EV_InitPos_m: 578.6578,
              EV_InitSpd_Kmph: 80,
              Overlap_per: 50,
              Tgt_InitPos_m: 899.18207654321,
              Tgt_InitSpd_Kmph: 70,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 10.06 km/h.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0508080-n090",
            InputParameters: {
              EV_InitPos_m: 578.6578,
              EV_InitSpd_Kmph: 80,
              Overlap_per: 50,
              Tgt_InitPos_m: 882.16583670949854,
              Tgt_InitSpd_Kmph: 80,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 10.06 km/h.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0508090-n090",
            InputParameters: {
              EV_InitPos_m: 578.6578,
              EV_InitSpd_Kmph: 80,
              Overlap_per: 50,
              Tgt_InitPos_m: 864.36224489795916,
              Tgt_InitSpd_Kmph: 90,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0508096-n090",
            InputParameters: {
              EV_InitPos_m: 578.6578,
              EV_InitSpd_Kmph: 80,
              Overlap_per: 50,
              Tgt_InitPos_m: 853.30212086167808,
              Tgt_InitSpd_Kmph: 96,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0509020-n090",
            InputParameters: {
              EV_InitPos_m: 525.88,
              EV_InitSpd_Kmph: 90,
              Overlap_per: 50,
              Tgt_InitPos_m: 972.45309604434362,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 52.41 km/h.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0509030-n090",
            InputParameters: {
              EV_InitPos_m: 525.88,
              EV_InitSpd_Kmph: 90,
              Overlap_per: 50,
              Tgt_InitPos_m: 959.37361609977324,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0509040-n090",
            InputParameters: {
              EV_InitPos_m: 525.88,
              EV_InitSpd_Kmph: 90,
              Overlap_per: 50,
              Tgt_InitPos_m: 945.5067841773747,
              Tgt_InitSpd_Kmph: 40,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 16.99 km/h.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0509050-n090",
            InputParameters: {
              EV_InitPos_m: 525.88,
              EV_InitSpd_Kmph: 90,
              Overlap_per: 50,
              Tgt_InitPos_m: 930.8525002771479,
              Tgt_InitSpd_Kmph: 50,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 13.72 km/h.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0509060-n090",
            InputParameters: {
              EV_InitPos_m: 525.88,
              EV_InitSpd_Kmph: 90,
              Overlap_per: 50,
              Tgt_InitPos_m: 915.410964399093,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 10.46 km/h.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0509070-n090",
            InputParameters: {
              EV_InitPos_m: 525.88,
              EV_InitSpd_Kmph: 90,
              Overlap_per: 50,
              Tgt_InitPos_m: 899.18207654321,
              Tgt_InitSpd_Kmph: 70,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 10.46 km/h.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0509080-n090",
            InputParameters: {
              EV_InitPos_m: 525.88,
              EV_InitSpd_Kmph: 90,
              Overlap_per: 50,
              Tgt_InitPos_m: 882.16583670949854,
              Tgt_InitSpd_Kmph: 80,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 10.46 km/h.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0509090-n090",
            InputParameters: {
              EV_InitPos_m: 525.88,
              EV_InitSpd_Kmph: 90,
              Overlap_per: 50,
              Tgt_InitPos_m: 864.36224489795916,
              Tgt_InitSpd_Kmph: 90,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0509096-n090",
            InputParameters: {
              EV_InitPos_m: 525.88,
              EV_InitSpd_Kmph: 90,
              Overlap_per: 50,
              Tgt_InitPos_m: 853.30212086167808,
              Tgt_InitSpd_Kmph: 96,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 7.17 km/h.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0509620-n090",
            InputParameters: {
              EV_InitPos_m: 494.2133,
              EV_InitSpd_Kmph: 96,
              Overlap_per: 50,
              Tgt_InitPos_m: 972.45309604434362,
              Tgt_InitSpd_Kmph: 20,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 50.42 km/h.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0509630-n090",
            InputParameters: {
              EV_InitPos_m: 494.2133,
              EV_InitSpd_Kmph: 96,
              Overlap_per: 50,
              Tgt_InitPos_m: 959.37361609977324,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0509640-n090",
            InputParameters: {
              EV_InitPos_m: 494.2133,
              EV_InitSpd_Kmph: 96,
              Overlap_per: 50,
              Tgt_InitPos_m: 945.5067841773747,
              Tgt_InitSpd_Kmph: 40,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 20.31 km/h.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0509650-n090",
            InputParameters: {
              EV_InitPos_m: 494.2133,
              EV_InitSpd_Kmph: 96,
              Overlap_per: 50,
              Tgt_InitPos_m: 930.8525002771479,
              Tgt_InitSpd_Kmph: 50,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 13.82 km/h.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0509660-n090",
            InputParameters: {
              EV_InitPos_m: 494.2133,
              EV_InitSpd_Kmph: 96,
              Overlap_per: 50,
              Tgt_InitPos_m: 915.410964399093,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 13.82 km/h.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0509670-n090",
            InputParameters: {
              EV_InitPos_m: 494.2133,
              EV_InitSpd_Kmph: 96,
              Overlap_per: 50,
              Tgt_InitPos_m: 899.18207654321,
              Tgt_InitSpd_Kmph: 70,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 10.57 km/h.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0509680-n090",
            InputParameters: {
              EV_InitPos_m: 494.2133,
              EV_InitSpd_Kmph: 96,
              Overlap_per: 50,
              Tgt_InitPos_m: 882.16583670949854,
              Tgt_InitSpd_Kmph: 80,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 10.57 km/h.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0509690-n090",
            InputParameters: {
              EV_InitPos_m: 494.2133,
              EV_InitSpd_Kmph: 96,
              Overlap_per: 50,
              Tgt_InitPos_m: 864.36224489795916,
              Tgt_InitSpd_Kmph: 90,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Speed dropped by 10.57 km/h.",
          },
          {
            uuid: "1400HND_LC142742",
            name: "p0509696-n090",
            InputParameters: {
              EV_InitPos_m: 494.2133,
              EV_InitSpd_Kmph: 96,
              Overlap_per: 50,
              Tgt_InitPos_m: 853.30212086167808,
              Tgt_InitSpd_Kmph: 96,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
        ],
      },
      {
        execution_id: "20240610142742",
        summary: {
          uuid: "1500EUR142742",
          Scenario: "1500EUR",
          Mandatory_Target: {
            Total_Variations_Executed: 2,
            Passed: 2,
            Failed: 0,
            Pass_Percentage: 100,
          },
          Development_Target: {
            Total_Variations_Executed: 2,
            Passed: 2,
            Failed: 0,
            Pass_Percentage: 100,
          },
        },
        variations: [
          {
            uuid: "1500EUR142742",
            name: "p1005050-p180",
            InputParameters: {
              EV_InitPos_m: 361,
              EV_InitSpd_Kmph: 50,
              Tgt_InitPos_m: 351.15810027714792,
              Tgt_InitSpd_Kmph: 50,
              Tgt_LatPos_m: 3.5,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1500EUR142742",
            name: "p1007070-p180",
            InputParameters: {
              EV_InitPos_m: 306,
              EV_InitSpd_Kmph: 70,
              Tgt_InitPos_m: 286.70987654320987,
              Tgt_InitSpd_Kmph: 70,
              Tgt_LatPos_m: 3.5,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
        ],
      },
    ],
  },
  20240610142923: {
    test_execution_history: {
      Test_case_execution_id: "20240610142923",
      Model: "CS300",
      Execution: "Closed Loop",
      Executed_by: "Application",
      StartedAt: "2024-02-02 08:10:23",
      Mandatory_Target: {
        Total_Variations_Executed: 142,
        Passed: 117,
        Failed: 25,
        Pass_Percentage: "82.39%",
      },
      Development_Target: {
        Total_Variations_Executed: 142,
        Passed: 117,
        Failed: 25,
        Pass_Percentage: "82.39%",
      },
      Status: "Complete",
      Total_Scenarios_Executed: 4,
      Scenarios_Executed: ["1100EUR", "1100HND", "1200JPN", "1600JPN"],
    },
    test_summary: [
      {
        execution_id: "20240610142923",
        summary: {
          uuid: "1100EUR142923",
          Scenario: "1100EUR",
          Mandatory_Target: {
            Total_Variations_Executed: 45,
            Passed: 45,
            Failed: 0,
            Pass_Percentage: 100,
          },
          Development_Target: {
            Total_Variations_Executed: 45,
            Passed: 45,
            Failed: 0,
            Pass_Percentage: 100,
          },
        },
        variations: [
          {
            uuid: "1100EUR142923",
            name: "n0501000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 10,
              Overlap_per: -50,
              Tgt_InitPos_m: 152.7778,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "n0501500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 15,
              Overlap_per: -50,
              Tgt_InitPos_m: 179.1667,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "n0502000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 20,
              Overlap_per: -50,
              Tgt_InitPos_m: 205.5556,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "n0502500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 25,
              Overlap_per: -50,
              Tgt_InitPos_m: 231.9444,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "n0503000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 30,
              Overlap_per: -50,
              Tgt_InitPos_m: 258.3333,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "n0503500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 35,
              Overlap_per: -50,
              Tgt_InitPos_m: 284.7222,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "n0504000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 40,
              Overlap_per: -50,
              Tgt_InitPos_m: 311.1111,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "n0504500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 45,
              Overlap_per: -50,
              Tgt_InitPos_m: 337.5,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "n0505000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 50,
              Overlap_per: -50,
              Tgt_InitPos_m: 363.8889,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "n0751000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 10,
              Overlap_per: -75,
              Tgt_InitPos_m: 152.7778,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "n0751500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 15,
              Overlap_per: -75,
              Tgt_InitPos_m: 179.1667,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "n0752000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 20,
              Overlap_per: -75,
              Tgt_InitPos_m: 205.5556,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "n0752500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 25,
              Overlap_per: -75,
              Tgt_InitPos_m: 231.9444,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "n0753000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 30,
              Overlap_per: -75,
              Tgt_InitPos_m: 258.3333,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "n0753500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 35,
              Overlap_per: -75,
              Tgt_InitPos_m: 284.7222,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "n0754000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 40,
              Overlap_per: -75,
              Tgt_InitPos_m: 311.1111,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "n0754500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 45,
              Overlap_per: -75,
              Tgt_InitPos_m: 337.5,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "n0755000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 50,
              Overlap_per: -75,
              Tgt_InitPos_m: 363.8889,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "p0501000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 10,
              Overlap_per: 50,
              Tgt_InitPos_m: 152.7778,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "p0501500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 15,
              Overlap_per: 50,
              Tgt_InitPos_m: 179.1667,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "p0502000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 20,
              Overlap_per: 50,
              Tgt_InitPos_m: 205.5556,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "p0502500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 25,
              Overlap_per: 50,
              Tgt_InitPos_m: 231.9444,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "p0503000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 30,
              Overlap_per: 50,
              Tgt_InitPos_m: 258.3333,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "p0503500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 35,
              Overlap_per: 50,
              Tgt_InitPos_m: 284.7222,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "p0504000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 40,
              Overlap_per: 50,
              Tgt_InitPos_m: 311.1111,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "p0504500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 45,
              Overlap_per: 50,
              Tgt_InitPos_m: 337.5,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "p0505000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 50,
              Overlap_per: 50,
              Tgt_InitPos_m: 363.8889,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "p0751000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 10,
              Overlap_per: 75,
              Tgt_InitPos_m: 152.7778,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "p0751500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 15,
              Overlap_per: 75,
              Tgt_InitPos_m: 179.1667,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "p0752000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 20,
              Overlap_per: 75,
              Tgt_InitPos_m: 205.5556,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "p0752500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 25,
              Overlap_per: 75,
              Tgt_InitPos_m: 231.9444,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "p0753000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 30,
              Overlap_per: 75,
              Tgt_InitPos_m: 258.3333,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "p0753500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 35,
              Overlap_per: 75,
              Tgt_InitPos_m: 284.7222,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "p0754000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 40,
              Overlap_per: 75,
              Tgt_InitPos_m: 311.1111,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "p0754500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 45,
              Overlap_per: 75,
              Tgt_InitPos_m: 337.5,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "p0755000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 50,
              Overlap_per: 75,
              Tgt_InitPos_m: 363.8889,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "p1001000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 10,
              Overlap_per: 100,
              Tgt_InitPos_m: 152.7778,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "p1001500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 15,
              Overlap_per: 100,
              Tgt_InitPos_m: 179.1667,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "p1002000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 20,
              Overlap_per: 100,
              Tgt_InitPos_m: 205.5556,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "p1002500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 25,
              Overlap_per: 100,
              Tgt_InitPos_m: 231.9444,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "p1003000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 30,
              Overlap_per: 100,
              Tgt_InitPos_m: 258.3333,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "p1003500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 35,
              Overlap_per: 100,
              Tgt_InitPos_m: 284.7222,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "p1004000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 40,
              Overlap_per: 100,
              Tgt_InitPos_m: 311.1111,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "p1004500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 45,
              Overlap_per: 100,
              Tgt_InitPos_m: 337.5,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100EUR142923",
            name: "p1005000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 50,
              Overlap_per: 100,
              Tgt_InitPos_m: 363.8889,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
        ],
      },
      {
        execution_id: "20240610142923",
        summary: {
          uuid: "1100HND142923",
          Scenario: "1100HND",
          Mandatory_Target: {
            Total_Variations_Executed: 55,
            Passed: 50,
            Failed: 5,
            Pass_Percentage: 90.91,
          },
          Development_Target: {
            Total_Variations_Executed: 55,
            Passed: 50,
            Failed: 5,
            Pass_Percentage: 90.91,
          },
        },
        variations: [
          {
            uuid: "1100HND142923",
            name: "n0500500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 5,
              Overlap_per: -50,
              Tgt_InitPos_m: 126.3889,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100HND142923",
            name: "n0505500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 55,
              Overlap_per: -50,
              Tgt_InitPos_m: 390.2778,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.74 sec.",
          },
          {
            uuid: "1100HND142923",
            name: "n0506000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 60,
              Overlap_per: -50,
              Tgt_InitPos_m: 416.6667,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100HND142923",
            name: "n0506500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 65,
              Overlap_per: -50,
              Tgt_InitPos_m: 443.0556,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1100HND142923",
            name: "n0507000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 70,
              Overlap_per: -50,
              Tgt_InitPos_m: 469.4444,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1100HND142923",
            name: "n0507500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 75,
              Overlap_per: -50,
              Tgt_InitPos_m: 495.8333,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1100HND142923",
            name: "n0508000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 80,
              Overlap_per: -50,
              Tgt_InitPos_m: 522.2222,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1100HND142923",
            name: "n0508500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 85,
              Overlap_per: -50,
              Tgt_InitPos_m: 548.6111,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1100HND142923",
            name: "n0509000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 90,
              Overlap_per: -50,
              Tgt_InitPos_m: 575,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1100HND142923",
            name: "n0509500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 95,
              Overlap_per: -50,
              Tgt_InitPos_m: 601.3889,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100HND142923",
            name: "n0509600-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 96,
              Overlap_per: -50,
              Tgt_InitPos_m: 606.6667,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100HND142923",
            name: "n0750500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 5,
              Overlap_per: -75,
              Tgt_InitPos_m: 126.3889,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100HND142923",
            name: "n0755500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 55,
              Overlap_per: -75,
              Tgt_InitPos_m: 390.2778,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.74 sec.",
          },
          {
            uuid: "1100HND142923",
            name: "n0756000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 60,
              Overlap_per: -75,
              Tgt_InitPos_m: 416.6667,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100HND142923",
            name: "n0756500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 65,
              Overlap_per: -75,
              Tgt_InitPos_m: 443.0556,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1100HND142923",
            name: "n0757000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 70,
              Overlap_per: -75,
              Tgt_InitPos_m: 469.4444,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1100HND142923",
            name: "n0757500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 75,
              Overlap_per: -75,
              Tgt_InitPos_m: 495.8333,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1100HND142923",
            name: "n0758000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 80,
              Overlap_per: -75,
              Tgt_InitPos_m: 522.2222,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1100HND142923",
            name: "n0758500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 85,
              Overlap_per: -75,
              Tgt_InitPos_m: 548.6111,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1100HND142923",
            name: "n0759000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 90,
              Overlap_per: -75,
              Tgt_InitPos_m: 575,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1100HND142923",
            name: "n0759500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 95,
              Overlap_per: -75,
              Tgt_InitPos_m: 601.3889,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100HND142923",
            name: "n0759600-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 96,
              Overlap_per: -75,
              Tgt_InitPos_m: 606.6667,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100HND142923",
            name: "p0500500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 5,
              Overlap_per: 50,
              Tgt_InitPos_m: 126.3889,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100HND142923",
            name: "p0505500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 55,
              Overlap_per: 50,
              Tgt_InitPos_m: 390.2778,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.74 sec.",
          },
          {
            uuid: "1100HND142923",
            name: "p0506000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 60,
              Overlap_per: 50,
              Tgt_InitPos_m: 416.6667,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100HND142923",
            name: "p0506500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 65,
              Overlap_per: 50,
              Tgt_InitPos_m: 443.0556,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1100HND142923",
            name: "p0507000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 50,
              Tgt_InitPos_m: 469.4444,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1100HND142923",
            name: "p0507500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 75,
              Overlap_per: 50,
              Tgt_InitPos_m: 495.8333,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1100HND142923",
            name: "p0508000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 80,
              Overlap_per: 50,
              Tgt_InitPos_m: 522.2222,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1100HND142923",
            name: "p0508500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 85,
              Overlap_per: 50,
              Tgt_InitPos_m: 548.6111,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1100HND142923",
            name: "p0509000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 90,
              Overlap_per: 50,
              Tgt_InitPos_m: 575,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1100HND142923",
            name: "p0509500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 95,
              Overlap_per: 50,
              Tgt_InitPos_m: 601.3889,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100HND142923",
            name: "p0509600-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 96,
              Overlap_per: 50,
              Tgt_InitPos_m: 606.6667,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100HND142923",
            name: "p0750500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 5,
              Overlap_per: 75,
              Tgt_InitPos_m: 126.3889,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100HND142923",
            name: "p0755500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 55,
              Overlap_per: 75,
              Tgt_InitPos_m: 390.2778,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.74 sec.",
          },
          {
            uuid: "1100HND142923",
            name: "p0756000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 60,
              Overlap_per: 75,
              Tgt_InitPos_m: 416.6667,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100HND142923",
            name: "p0756500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 65,
              Overlap_per: 75,
              Tgt_InitPos_m: 443.0556,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1100HND142923",
            name: "p0757000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 75,
              Tgt_InitPos_m: 469.4444,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1100HND142923",
            name: "p0757500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 75,
              Overlap_per: 75,
              Tgt_InitPos_m: 495.8333,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1100HND142923",
            name: "p0758000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 80,
              Overlap_per: 75,
              Tgt_InitPos_m: 522.2222,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1100HND142923",
            name: "p0758500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 85,
              Overlap_per: 75,
              Tgt_InitPos_m: 548.6111,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1100HND142923",
            name: "p0759000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 90,
              Overlap_per: 75,
              Tgt_InitPos_m: 575,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1100HND142923",
            name: "p0759500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 95,
              Overlap_per: 75,
              Tgt_InitPos_m: 601.3889,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100HND142923",
            name: "p0759600-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 96,
              Overlap_per: 75,
              Tgt_InitPos_m: 606.6667,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100HND142923",
            name: "p1000500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 5,
              Overlap_per: 100,
              Tgt_InitPos_m: 126.3889,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100HND142923",
            name: "p1005500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 55,
              Overlap_per: 100,
              Tgt_InitPos_m: 390.2778,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 19.74 sec.",
          },
          {
            uuid: "1100HND142923",
            name: "p1006000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 60,
              Overlap_per: 100,
              Tgt_InitPos_m: 416.6667,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100HND142923",
            name: "p1006500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 65,
              Overlap_per: 100,
              Tgt_InitPos_m: 443.0556,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1100HND142923",
            name: "p1007000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 70,
              Overlap_per: 100,
              Tgt_InitPos_m: 469.4444,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1100HND142923",
            name: "p1007500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 75,
              Overlap_per: 100,
              Tgt_InitPos_m: 495.8333,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1100HND142923",
            name: "p1008000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 80,
              Overlap_per: 100,
              Tgt_InitPos_m: 522.2222,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1100HND142923",
            name: "p1008500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 85,
              Overlap_per: 100,
              Tgt_InitPos_m: 548.6111,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1100HND142923",
            name: "p1009000-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 90,
              Overlap_per: 100,
              Tgt_InitPos_m: 575,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "No collision occurred.",
          },
          {
            uuid: "1100HND142923",
            name: "p1009500-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 95,
              Overlap_per: 100,
              Tgt_InitPos_m: 601.3889,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1100HND142923",
            name: "p1009600-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 96,
              Overlap_per: 100,
              Tgt_InitPos_m: 606.6667,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
        ],
      },
      {
        execution_id: "20240610142923",
        summary: {
          uuid: "1200JPN142923",
          Scenario: "1200JPN",
          Mandatory_Target: {
            Total_Variations_Executed: 6,
            Passed: 6,
            Failed: 0,
            Pass_Percentage: 100,
          },
          Development_Target: {
            Total_Variations_Executed: 6,
            Passed: 6,
            Failed: 0,
            Pass_Percentage: 100,
          },
        },
        variations: [
          {
            uuid: "1200JPN142923",
            name: "p1003520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 35,
              Overlap_per: 100,
              Tgt_InitPos_m: 237.31419604434367,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 1.75,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200JPN142923",
            name: "p1004020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 40,
              Overlap_per: 100,
              Tgt_InitPos_m: 265.09199604434366,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 1.75,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200JPN142923",
            name: "p1004520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 45,
              Overlap_per: 100,
              Tgt_InitPos_m: 292.86969604434364,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 1.75,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200JPN142923",
            name: "p1005020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 50,
              Overlap_per: 100,
              Tgt_InitPos_m: 320.64749604434365,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 1.75,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200JPN142923",
            name: "p1005520-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 55,
              Overlap_per: 100,
              Tgt_InitPos_m: 348.42529604434367,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 1.75,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1200JPN142923",
            name: "p1006020-p000",
            InputParameters: {
              EV_InitPos_m: 100,
              EV_InitSpd_Kmph: 60,
              Overlap_per: 100,
              Tgt_InitPos_m: 376.20309604434368,
              Tgt_InitSpd_Kmph: 20,
              Tgt_LatPos_m: 1.75,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
        ],
      },
      {
        execution_id: "20240610142923",
        summary: {
          uuid: "1600JPN142923",
          Scenario: "1600JPN",
          Mandatory_Target: {
            Total_Variations_Executed: 36,
            Passed: 16,
            Failed: 20,
            Pass_Percentage: 44.44,
          },
          Development_Target: {
            Total_Variations_Executed: 36,
            Passed: 16,
            Failed: 20,
            Pass_Percentage: 44.44,
          },
        },
        variations: [
          {
            uuid: "1600JPN142923",
            name: "p0501030-n090_CP1",
            InputParameters: {
              Curved_Buffer_m: 6.6,
              EV_ColPoint_m: 1996.675,
              EV_InitPos_m: 1949.9,
              EV_InitSpd_Kmph: 10,
              EV_StartCond_m: 1988.5,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1953.9569160997733,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 17.02 sec.",
          },
          {
            uuid: "1600JPN142923",
            name: "p0501040-n090_CP1",
            InputParameters: {
              Curved_Buffer_m: 6.6,
              EV_ColPoint_m: 1996.675,
              EV_InitPos_m: 1949.9,
              EV_InitSpd_Kmph: 10,
              EV_StartCond_m: 1988.5,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1937.0011841773746,
              Tgt_InitSpd_Kmph: 40,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1600JPN142923",
            name: "p0501050-n090_CP1",
            InputParameters: {
              Curved_Buffer_m: 6.6,
              EV_ColPoint_m: 1996.675,
              EV_InitPos_m: 1949.9,
              EV_InitSpd_Kmph: 10,
              EV_StartCond_m: 1988.5,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1919.858100277148,
              Tgt_InitSpd_Kmph: 50,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1600JPN142923",
            name: "p0501060-n090_CP1",
            InputParameters: {
              Curved_Buffer_m: 6.6,
              EV_ColPoint_m: 1996.675,
              EV_InitPos_m: 1949.9,
              EV_InitSpd_Kmph: 10,
              EV_StartCond_m: 1988.5,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1900.827664399093,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1600JPN142923",
            name: "p0501530-n090_CP1",
            InputParameters: {
              Curved_Buffer_m: 5.95,
              EV_ColPoint_m: 1995.873,
              EV_InitPos_m: 1925.7,
              EV_InitSpd_Kmph: 15,
              EV_StartCond_m: 1984.5,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1951.9569160997733,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 16.80 sec.",
          },
          {
            uuid: "1600JPN142923",
            name: "p0501540-n090_CP1",
            InputParameters: {
              Curved_Buffer_m: 5.95,
              EV_ColPoint_m: 1995.873,
              EV_InitPos_m: 1925.7,
              EV_InitSpd_Kmph: 15,
              EV_StartCond_m: 1984.5,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1934.0011841773746,
              Tgt_InitSpd_Kmph: 40,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 16.86 sec.",
          },
          {
            uuid: "1600JPN142923",
            name: "p0501550-n090_CP1",
            InputParameters: {
              Curved_Buffer_m: 5.95,
              EV_ColPoint_m: 1995.873,
              EV_InitPos_m: 1925.7,
              EV_InitSpd_Kmph: 15,
              EV_StartCond_m: 1984.5,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1915.4581002771479,
              Tgt_InitSpd_Kmph: 50,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 16.83 sec.",
          },
          {
            uuid: "1600JPN142923",
            name: "p0501560-n090_CP1",
            InputParameters: {
              Curved_Buffer_m: 5.95,
              EV_ColPoint_m: 1995.873,
              EV_InitPos_m: 1925.7,
              EV_InitSpd_Kmph: 15,
              EV_StartCond_m: 1984.5,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1896.327664399093,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 16.80 sec.",
          },
          {
            uuid: "1600JPN142923",
            name: "p0502030-n090_CP1",
            InputParameters: {
              Curved_Buffer_m: 8.4,
              EV_ColPoint_m: 1995.025,
              EV_InitPos_m: 1901.475,
              EV_InitSpd_Kmph: 20,
              EV_StartCond_m: 1980,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1955.9569160997733,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 16.69 sec.",
          },
          {
            uuid: "1600JPN142923",
            name: "p0502040-n090_CP1",
            InputParameters: {
              Curved_Buffer_m: 8.4,
              EV_ColPoint_m: 1995.025,
              EV_InitPos_m: 1901.475,
              EV_InitSpd_Kmph: 20,
              EV_StartCond_m: 1980,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1938.7011841773747,
              Tgt_InitSpd_Kmph: 40,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 16.60 sec.",
          },
          {
            uuid: "1600JPN142923",
            name: "p0502050-n090_CP1",
            InputParameters: {
              Curved_Buffer_m: 8.4,
              EV_ColPoint_m: 1995.025,
              EV_InitPos_m: 1901.475,
              EV_InitSpd_Kmph: 20,
              EV_StartCond_m: 1980,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1920.858100277148,
              Tgt_InitSpd_Kmph: 50,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 16.65 sec.",
          },
          {
            uuid: "1600JPN142923",
            name: "p0502060-n090_CP1",
            InputParameters: {
              Curved_Buffer_m: 8.4,
              EV_ColPoint_m: 1995.025,
              EV_InitPos_m: 1901.475,
              EV_InitSpd_Kmph: 20,
              EV_StartCond_m: 1980,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1902.127664399093,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 16.66 sec.",
          },
          {
            uuid: "1600JPN142923",
            name: "p1001030-n090_CP2",
            InputParameters: {
              Curved_Buffer_m: 6.6,
              EV_ColPoint_m: 1996.675,
              EV_InitPos_m: 1949.9,
              EV_InitSpd_Kmph: 10,
              EV_StartCond_m: 1988.5,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1949.9569160997733,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 17.39 sec.",
          },
          {
            uuid: "1600JPN142923",
            name: "p1001030-n090_CP3",
            InputParameters: {
              Curved_Buffer_m: 6.6,
              EV_ColPoint_m: 1996.675,
              EV_InitPos_m: 1949.9,
              EV_InitSpd_Kmph: 10,
              EV_StartCond_m: 1988.5,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1946.4569160997733,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 17.78 sec.",
          },
          {
            uuid: "1600JPN142923",
            name: "p1001040-n090_CP2",
            InputParameters: {
              Curved_Buffer_m: 6.6,
              EV_ColPoint_m: 1996.675,
              EV_InitPos_m: 1949.9,
              EV_InitSpd_Kmph: 10,
              EV_StartCond_m: 1988.5,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1932.2011841773747,
              Tgt_InitSpd_Kmph: 40,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1600JPN142923",
            name: "p1001040-n090_CP3",
            InputParameters: {
              Curved_Buffer_m: 6.6,
              EV_ColPoint_m: 1996.675,
              EV_InitPos_m: 1949.9,
              EV_InitSpd_Kmph: 10,
              EV_StartCond_m: 1988.5,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1927.9011841773747,
              Tgt_InitSpd_Kmph: 40,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1600JPN142923",
            name: "p1001050-n090_CP2",
            InputParameters: {
              Curved_Buffer_m: 6.6,
              EV_ColPoint_m: 1996.675,
              EV_InitPos_m: 1949.9,
              EV_InitSpd_Kmph: 10,
              EV_StartCond_m: 1988.5,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1913.858100277148,
              Tgt_InitSpd_Kmph: 50,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1600JPN142923",
            name: "p1001050-n090_CP3",
            InputParameters: {
              Curved_Buffer_m: 6.6,
              EV_ColPoint_m: 1996.675,
              EV_InitPos_m: 1949.9,
              EV_InitSpd_Kmph: 10,
              EV_StartCond_m: 1988.5,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1908.1581002771479,
              Tgt_InitSpd_Kmph: 50,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1600JPN142923",
            name: "p1001060-n090_CP2",
            InputParameters: {
              Curved_Buffer_m: 6.6,
              EV_ColPoint_m: 1996.675,
              EV_InitPos_m: 1949.9,
              EV_InitSpd_Kmph: 10,
              EV_StartCond_m: 1988.5,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1894.827664399093,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1600JPN142923",
            name: "p1001060-n090_CP3",
            InputParameters: {
              Curved_Buffer_m: 6.6,
              EV_ColPoint_m: 1996.675,
              EV_InitPos_m: 1949.9,
              EV_InitSpd_Kmph: 10,
              EV_StartCond_m: 1988.5,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1888.327664399093,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1600JPN142923",
            name: "p1001530-n090_CP2",
            InputParameters: {
              Curved_Buffer_m: 5.95,
              EV_ColPoint_m: 1995.873,
              EV_InitPos_m: 1925.7,
              EV_InitSpd_Kmph: 15,
              EV_StartCond_m: 1984.5,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1948.4569160997733,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1600JPN142923",
            name: "p1001530-n090_CP3",
            InputParameters: {
              Curved_Buffer_m: 5.95,
              EV_ColPoint_m: 1995.873,
              EV_InitPos_m: 1925.7,
              EV_InitSpd_Kmph: 15,
              EV_StartCond_m: 1984.5,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1945.4569160997733,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1600JPN142923",
            name: "p1001540-n090_CP2",
            InputParameters: {
              Curved_Buffer_m: 5.95,
              EV_ColPoint_m: 1995.873,
              EV_InitPos_m: 1925.7,
              EV_InitSpd_Kmph: 15,
              EV_StartCond_m: 1984.5,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1930.0011841773746,
              Tgt_InitSpd_Kmph: 40,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1600JPN142923",
            name: "p1001540-n090_CP3",
            InputParameters: {
              Curved_Buffer_m: 5.95,
              EV_ColPoint_m: 1995.873,
              EV_InitPos_m: 1925.7,
              EV_InitSpd_Kmph: 15,
              EV_StartCond_m: 1984.5,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1926.7011841773747,
              Tgt_InitSpd_Kmph: 40,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1600JPN142923",
            name: "p1001550-n090_CP2",
            InputParameters: {
              Curved_Buffer_m: 5.95,
              EV_ColPoint_m: 1995.873,
              EV_InitPos_m: 1925.7,
              EV_InitSpd_Kmph: 15,
              EV_StartCond_m: 1984.5,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1910.4581002771479,
              Tgt_InitSpd_Kmph: 50,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1600JPN142923",
            name: "p1001550-n090_CP3",
            InputParameters: {
              Curved_Buffer_m: 5.95,
              EV_ColPoint_m: 1995.873,
              EV_InitPos_m: 1925.7,
              EV_InitSpd_Kmph: 15,
              EV_StartCond_m: 1984.5,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1906.1581002771479,
              Tgt_InitSpd_Kmph: 50,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1600JPN142923",
            name: "p1001560-n090_CP2",
            InputParameters: {
              Curved_Buffer_m: 5.95,
              EV_ColPoint_m: 1995.873,
              EV_InitPos_m: 1925.7,
              EV_InitSpd_Kmph: 15,
              EV_StartCond_m: 1984.5,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1890.327664399093,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 17.13 sec.",
          },
          {
            uuid: "1600JPN142923",
            name: "p1001560-n090_CP3",
            InputParameters: {
              Curved_Buffer_m: 5.95,
              EV_ColPoint_m: 1995.873,
              EV_InitPos_m: 1925.7,
              EV_InitSpd_Kmph: 15,
              EV_StartCond_m: 1984.5,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1885.327664399093,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "PASS" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "PASS" },
            Remarks: "",
          },
          {
            uuid: "1600JPN142923",
            name: "p1002030-n090_CP2",
            InputParameters: {
              Curved_Buffer_m: 8.4,
              EV_ColPoint_m: 1995.025,
              EV_InitPos_m: 1901.475,
              EV_InitSpd_Kmph: 20,
              EV_StartCond_m: 1980,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1952.9569160997733,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 16.81 sec.",
          },
          {
            uuid: "1600JPN142923",
            name: "p1002030-n090_CP3",
            InputParameters: {
              Curved_Buffer_m: 8.4,
              EV_ColPoint_m: 1995.025,
              EV_InitPos_m: 1901.475,
              EV_InitSpd_Kmph: 20,
              EV_StartCond_m: 1980,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1949.9569160997733,
              Tgt_InitSpd_Kmph: 30,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 17.40 sec.",
          },
          {
            uuid: "1600JPN142923",
            name: "p1002040-n090_CP2",
            InputParameters: {
              Curved_Buffer_m: 8.4,
              EV_ColPoint_m: 1995.025,
              EV_InitPos_m: 1901.475,
              EV_InitSpd_Kmph: 20,
              EV_StartCond_m: 1980,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1934.7011841773747,
              Tgt_InitSpd_Kmph: 40,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 16.84 sec.",
          },
          {
            uuid: "1600JPN142923",
            name: "p1002040-n090_CP3",
            InputParameters: {
              Curved_Buffer_m: 8.4,
              EV_ColPoint_m: 1995.025,
              EV_InitPos_m: 1901.475,
              EV_InitSpd_Kmph: 20,
              EV_StartCond_m: 1980,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1931.7011841773747,
              Tgt_InitSpd_Kmph: 40,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 17.29 sec.",
          },
          {
            uuid: "1600JPN142923",
            name: "p1002050-n090_CP2",
            InputParameters: {
              Curved_Buffer_m: 8.4,
              EV_ColPoint_m: 1995.025,
              EV_InitPos_m: 1901.475,
              EV_InitSpd_Kmph: 20,
              EV_StartCond_m: 1980,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1916.1581002771479,
              Tgt_InitSpd_Kmph: 50,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 17.01 sec.",
          },
          {
            uuid: "1600JPN142923",
            name: "p1002050-n090_CP3",
            InputParameters: {
              Curved_Buffer_m: 8.4,
              EV_ColPoint_m: 1995.025,
              EV_InitPos_m: 1901.475,
              EV_InitSpd_Kmph: 20,
              EV_StartCond_m: 1980,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1912.1581002771479,
              Tgt_InitSpd_Kmph: 50,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 17.30 sec.",
          },
          {
            uuid: "1600JPN142923",
            name: "p1002060-n090_CP2",
            InputParameters: {
              Curved_Buffer_m: 8.4,
              EV_ColPoint_m: 1995.025,
              EV_InitPos_m: 1901.475,
              EV_InitSpd_Kmph: 20,
              EV_StartCond_m: 1980,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1896.827664399093,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 16.98 sec.",
          },
          {
            uuid: "1600JPN142923",
            name: "p1002060-n090_CP3",
            InputParameters: {
              Curved_Buffer_m: 8.4,
              EV_ColPoint_m: 1995.025,
              EV_InitPos_m: 1901.475,
              EV_InitSpd_Kmph: 20,
              EV_StartCond_m: 1980,
              TTC_s: 6.84,
              Tgt_InitPos_m: 1892.327664399093,
              Tgt_InitSpd_Kmph: 60,
            },
            MandatoryTarget: { KPI: "Avoidance", Result: "FAIL" },
            DevelopmentTarget: { KPI: "Avoidance", Result: "FAIL" },
            Remarks: "Collision occurred at 17.25 sec.",
          },
        ],
      },
    ],
  },
  20240610140646: {
    test_execution_history: {
      Test_case_execution_id: "20240610140646",
      Model: "CS300",
      Execution: "Closed Loop",
      Executed_by: "Application",
      StartedAt: "2024-02-02 03:08:23",
      Mandatory_Target: {},
      Development_Target: {},
      Status: "Failed",
      Total_Scenarios_Executed: 0,
      Scenarios_Executed: [],
    },
  },
};
